(function (e) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "undefined" != typeof exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (c) {
    "use strict";
    var n,
      s = window.Slick || {};
    (n = 0),
      ((s = function (e, t) {
        var i = this;
        (i.defaults = {
          accessibility: !0,
          adaptiveHeight: !1,
          appendArrows: c(e),
          appendDots: c(e),
          arrows: !0,
          asNavFor: null,
          prevArrow:
            '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
          nextArrow:
            '<button class="slick-next" aria-label="Next" type="button">Next</button>',
          autoplay: !1,
          autoplaySpeed: 3e3,
          centerMode: !1,
          centerPadding: "50px",
          cssEase: "ease",
          customPaging: function (e, t) {
            return c('<button type="button" />').text(t + 1);
          },
          dots: !1,
          dotsClass: "slick-dots",
          draggable: !0,
          easing: "linear",
          edgeFriction: 0.35,
          fade: !1,
          focusOnSelect: !1,
          focusOnChange: !1,
          infinite: !0,
          initialSlide: 0,
          lazyLoad: "ondemand",
          mobileFirst: !1,
          pauseOnHover: !0,
          pauseOnFocus: !0,
          pauseOnDotsHover: !1,
          respondTo: "window",
          responsive: null,
          rows: 1,
          rtl: !1,
          slide: "",
          slidesPerRow: 1,
          slidesToShow: 1,
          slidesToScroll: 1,
          speed: 500,
          swipe: !0,
          swipeToSlide: !1,
          touchMove: !0,
          touchThreshold: 5,
          useCSS: !0,
          useTransform: !0,
          variableWidth: !1,
          vertical: !1,
          verticalSwiping: !1,
          waitForAnimate: !0,
          zIndex: 1e3,
        }),
          (i.initials = {
            animating: !1,
            dragging: !1,
            autoPlayTimer: null,
            currentDirection: 0,
            currentLeft: null,
            currentSlide: 0,
            direction: 1,
            $dots: null,
            listWidth: null,
            listHeight: null,
            loadIndex: 0,
            $nextArrow: null,
            $prevArrow: null,
            scrolling: !1,
            slideCount: null,
            slideWidth: null,
            $slideTrack: null,
            $slides: null,
            sliding: !1,
            slideOffset: 0,
            swipeLeft: null,
            swiping: !1,
            $list: null,
            touchObject: {},
            transformsEnabled: !1,
            unslicked: !1,
          }),
          c.extend(i, i.initials),
          (i.activeBreakpoint = null),
          (i.animType = null),
          (i.animProp = null),
          (i.breakpoints = []),
          (i.breakpointSettings = []),
          (i.cssTransitions = !1),
          (i.focussed = !1),
          (i.interrupted = !1),
          (i.hidden = "hidden"),
          (i.paused = !0),
          (i.positionProp = null),
          (i.respondTo = null),
          (i.rowCount = 1),
          (i.shouldClick = !0),
          (i.$slider = c(e)),
          (i.$slidesCache = null),
          (i.transformType = null),
          (i.transitionType = null),
          (i.visibilityChange = "visibilitychange"),
          (i.windowWidth = 0),
          (i.windowTimer = null),
          (e = c(e).data("slick") || {}),
          (i.options = c.extend({}, i.defaults, t, e)),
          (i.currentSlide = i.options.initialSlide),
          (i.originalSettings = i.options),
          void 0 !== document.mozHidden
            ? ((i.hidden = "mozHidden"),
              (i.visibilityChange = "mozvisibilitychange"))
            : void 0 !== document.webkitHidden &&
              ((i.hidden = "webkitHidden"),
              (i.visibilityChange = "webkitvisibilitychange")),
          (i.autoPlay = c.proxy(i.autoPlay, i)),
          (i.autoPlayClear = c.proxy(i.autoPlayClear, i)),
          (i.autoPlayIterator = c.proxy(i.autoPlayIterator, i)),
          (i.changeSlide = c.proxy(i.changeSlide, i)),
          (i.clickHandler = c.proxy(i.clickHandler, i)),
          (i.selectHandler = c.proxy(i.selectHandler, i)),
          (i.setPosition = c.proxy(i.setPosition, i)),
          (i.swipeHandler = c.proxy(i.swipeHandler, i)),
          (i.dragHandler = c.proxy(i.dragHandler, i)),
          (i.keyHandler = c.proxy(i.keyHandler, i)),
          (i.instanceUid = n++),
          (i.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
          i.registerBreakpoints(),
          i.init(!0);
      }).prototype.activateADA = function () {
        this.$slideTrack
          .find(".slick-active")
          .attr({ "aria-hidden": "false" })
          .find("a, input, button, select")
          .attr({ tabindex: "0" });
      }),
      (s.prototype.addSlide = s.prototype.slickAdd =
        function (e, t, i) {
          var n = this;
          if ("boolean" == typeof t) (i = t), (t = null);
          else if (t < 0 || t >= n.slideCount) return !1;
          n.unload(),
            "number" == typeof t
              ? 0 === t && 0 === n.$slides.length
                ? c(e).appendTo(n.$slideTrack)
                : i
                ? c(e).insertBefore(n.$slides.eq(t))
                : c(e).insertAfter(n.$slides.eq(t))
              : !0 === i
              ? c(e).prependTo(n.$slideTrack)
              : c(e).appendTo(n.$slideTrack),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            n.$slides.each(function (e, t) {
              c(t).attr("data-slick-index", e);
            }),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
      (s.prototype.animateHeight = function () {
        var e,
          t = this;
        1 === t.options.slidesToShow &&
          !0 === t.options.adaptiveHeight &&
          !1 === t.options.vertical &&
          ((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
          t.$list.animate({ height: e }, t.options.speed));
      }),
      (s.prototype.animateSlide = function (e, t) {
        var i = {},
          n = this;
        n.animateHeight(),
          !0 === n.options.rtl && !1 === n.options.vertical && (e = -e),
          !1 === n.transformsEnabled
            ? !1 === n.options.vertical
              ? n.$slideTrack.animate(
                  { left: e },
                  n.options.speed,
                  n.options.easing,
                  t
                )
              : n.$slideTrack.animate(
                  { top: e },
                  n.options.speed,
                  n.options.easing,
                  t
                )
            : !1 === n.cssTransitions
            ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft),
              c({ animStart: n.currentLeft }).animate(
                { animStart: e },
                {
                  duration: n.options.speed,
                  easing: n.options.easing,
                  step: function (e) {
                    (e = Math.ceil(e)),
                      !1 === n.options.vertical
                        ? (i[n.animType] = "translate(" + e + "px, 0px)")
                        : (i[n.animType] = "translate(0px," + e + "px)"),
                      n.$slideTrack.css(i);
                  },
                  complete: function () {
                    t && t.call();
                  },
                }
              ))
            : (n.applyTransition(),
              (e = Math.ceil(e)),
              !1 === n.options.vertical
                ? (i[n.animType] = "translate3d(" + e + "px, 0px, 0px)")
                : (i[n.animType] = "translate3d(0px," + e + "px, 0px)"),
              n.$slideTrack.css(i),
              t &&
                setTimeout(function () {
                  n.disableTransition(), t.call();
                }, n.options.speed));
      }),
      (s.prototype.getNavTarget = function () {
        var e = this.options.asNavFor;
        return (e = e && null !== e ? c(e).not(this.$slider) : e);
      }),
      (s.prototype.asNavFor = function (t) {
        var e = this.getNavTarget();
        null !== e &&
          "object" == typeof e &&
          e.each(function () {
            var e = c(this).slick("getSlick");
            e.unslicked || e.slideHandler(t, !0);
          });
      }),
      (s.prototype.applyTransition = function (e) {
        var t = this,
          i = {};
        !1 === t.options.fade
          ? (i[t.transitionType] =
              t.transformType +
              " " +
              t.options.speed +
              "ms " +
              t.options.cssEase)
          : (i[t.transitionType] =
              "opacity " + t.options.speed + "ms " + t.options.cssEase),
          (!1 === t.options.fade ? t.$slideTrack : t.$slides.eq(e)).css(i);
      }),
      (s.prototype.autoPlay = function () {
        var e = this;
        e.autoPlayClear(),
          e.slideCount > e.options.slidesToShow &&
            (e.autoPlayTimer = setInterval(
              e.autoPlayIterator,
              e.options.autoplaySpeed
            ));
      }),
      (s.prototype.autoPlayClear = function () {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer);
      }),
      (s.prototype.autoPlayIterator = function () {
        var e = this,
          t = e.currentSlide + e.options.slidesToScroll;
        e.paused ||
          e.interrupted ||
          e.focussed ||
          (!1 === e.options.infinite &&
            (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1
              ? (e.direction = 0)
              : 0 === e.direction &&
                ((t = e.currentSlide - e.options.slidesToScroll),
                e.currentSlide - 1 == 0 && (e.direction = 1))),
          e.slideHandler(t));
      }),
      (s.prototype.buildArrows = function () {
        var e = this;
        !0 === e.options.arrows &&
          ((e.$prevArrow = c(e.options.prevArrow).addClass("slick-arrow")),
          (e.$nextArrow = c(e.options.nextArrow).addClass("slick-arrow")),
          e.slideCount > e.options.slidesToShow
            ? (e.$prevArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.$nextArrow
                .removeClass("slick-hidden")
                .removeAttr("aria-hidden tabindex"),
              e.htmlExpr.test(e.options.prevArrow) &&
                e.$prevArrow.prependTo(e.options.appendArrows),
              e.htmlExpr.test(e.options.nextArrow) &&
                e.$nextArrow.appendTo(e.options.appendArrows),
              !0 !== e.options.infinite &&
                e.$prevArrow
                  .addClass("slick-disabled")
                  .attr("aria-disabled", "true"))
            : e.$prevArrow
                .add(e.$nextArrow)
                .addClass("slick-hidden")
                .attr({ "aria-disabled": "true", tabindex: "-1" }));
      }),
      (s.prototype.buildDots = function () {
        var e,
          t,
          i = this;
        if (!0 === i.options.dots && i.slideCount > i.options.slidesToShow) {
          for (
            i.$slider.addClass("slick-dotted"),
              t = c("<ul />").addClass(i.options.dotsClass),
              e = 0;
            e <= i.getDotCount();
            e += 1
          )
            t.append(
              c("<li />").append(i.options.customPaging.call(this, i, e))
            );
          (i.$dots = t.appendTo(i.options.appendDots)),
            i.$dots.find("li").first().addClass("slick-active");
        }
      }),
      (s.prototype.buildOut = function () {
        var e = this;
        (e.$slides = e.$slider
          .children(e.options.slide + ":not(.slick-cloned)")
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.$slides.each(function (e, t) {
            c(t)
              .attr("data-slick-index", e)
              .data("originalStyling", c(t).attr("style") || "");
          }),
          e.$slider.addClass("slick-slider"),
          (e.$slideTrack =
            0 === e.slideCount
              ? c('<div class="slick-track"/>').appendTo(e.$slider)
              : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
          (e.$list = e.$slideTrack.wrap('<div class="slick-list"/>').parent()),
          e.$slideTrack.css("opacity", 0),
          (!0 !== e.options.centerMode && !0 !== e.options.swipeToSlide) ||
            (e.options.slidesToScroll = 1),
          c("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
          e.setupInfinite(),
          e.buildArrows(),
          e.buildDots(),
          e.updateDots(),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          !0 === e.options.draggable && e.$list.addClass("draggable");
      }),
      (s.prototype.buildRows = function () {
        var e,
          t,
          i,
          n = this,
          o = document.createDocumentFragment(),
          r = n.$slider.children();
        if (0 < n.options.rows) {
          for (
            i = n.options.slidesPerRow * n.options.rows,
              t = Math.ceil(r.length / i),
              e = 0;
            e < t;
            e++
          ) {
            for (
              var s = document.createElement("div"), a = 0;
              a < n.options.rows;
              a++
            ) {
              for (
                var l = document.createElement("div"), c = 0;
                c < n.options.slidesPerRow;
                c++
              ) {
                var d = e * i + (a * n.options.slidesPerRow + c);
                r.get(d) && l.appendChild(r.get(d));
              }
              s.appendChild(l);
            }
            o.appendChild(s);
          }
          n.$slider.empty().append(o),
            n.$slider
              .children()
              .children()
              .children()
              .css({
                width: 100 / n.options.slidesPerRow + "%",
                display: "inline-block",
              });
        }
      }),
      (s.prototype.checkResponsive = function (e, t) {
        var i,
          n,
          o,
          r = this,
          s = !1,
          a = r.$slider.width(),
          l = window.innerWidth || c(window).width();
        if (
          ("window" === r.respondTo
            ? (o = l)
            : "slider" === r.respondTo
            ? (o = a)
            : "min" === r.respondTo && (o = Math.min(l, a)),
          r.options.responsive &&
            r.options.responsive.length &&
            null !== r.options.responsive)
        ) {
          for (i in ((n = null), r.breakpoints))
            r.breakpoints.hasOwnProperty(i) &&
              (!1 === r.originalSettings.mobileFirst
                ? o < r.breakpoints[i] && (n = r.breakpoints[i])
                : o > r.breakpoints[i] && (n = r.breakpoints[i]));
          null !== n
            ? (null !== r.activeBreakpoint && n === r.activeBreakpoint && !t) ||
              ((r.activeBreakpoint = n),
              "unslick" === r.breakpointSettings[n]
                ? r.unslick(n)
                : ((r.options = c.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[n]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (s = n))
            : null !== r.activeBreakpoint &&
              ((r.activeBreakpoint = null),
              (r.options = r.originalSettings),
              !0 === e && (r.currentSlide = r.options.initialSlide),
              r.refresh(e),
              (s = n)),
            e || !1 === s || r.$slider.trigger("breakpoint", [r, s]);
        }
      }),
      (s.prototype.changeSlide = function (e, t) {
        var i,
          n = this,
          o = c(e.currentTarget);
        switch (
          (o.is("a") && e.preventDefault(),
          o.is("li") || (o = o.closest("li")),
          (i =
            n.slideCount % n.options.slidesToScroll != 0
              ? 0
              : (n.slideCount - n.currentSlide) % n.options.slidesToScroll),
          e.data.message)
        ) {
          case "previous":
            (r =
              0 == i ? n.options.slidesToScroll : n.options.slidesToShow - i),
              n.slideCount > n.options.slidesToShow &&
                n.slideHandler(n.currentSlide - r, !1, t);
            break;
          case "next":
            (r = 0 == i ? n.options.slidesToScroll : i),
              n.slideCount > n.options.slidesToShow &&
                n.slideHandler(n.currentSlide + r, !1, t);
            break;
          case "index":
            var r =
              0 === e.data.index
                ? 0
                : e.data.index || o.index() * n.options.slidesToScroll;
            n.slideHandler(n.checkNavigable(r), !1, t),
              o.children().trigger("focus");
            break;
          default:
            return;
        }
      }),
      (s.prototype.checkNavigable = function (e) {
        var t = this.getNavigableIndexes(),
          i = 0;
        if (e > t[t.length - 1]) e = t[t.length - 1];
        else
          for (var n in t) {
            if (e < t[n]) {
              e = i;
              break;
            }
            i = t[n];
          }
        return e;
      }),
      (s.prototype.cleanUpEvents = function () {
        var e = this;
        e.options.dots &&
          null !== e.$dots &&
          (c("li", e.$dots)
            .off("click.slick", e.changeSlide)
            .off("mouseenter.slick", c.proxy(e.interrupt, e, !0))
            .off("mouseleave.slick", c.proxy(e.interrupt, e, !1)),
          !0 === e.options.accessibility &&
            e.$dots.off("keydown.slick", e.keyHandler)),
          e.$slider.off("focus.slick blur.slick"),
          !0 === e.options.arrows &&
            e.slideCount > e.options.slidesToShow &&
            (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
            e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide),
            !0 === e.options.accessibility &&
              (e.$prevArrow && e.$prevArrow.off("keydown.slick", e.keyHandler),
              e.$nextArrow && e.$nextArrow.off("keydown.slick", e.keyHandler))),
          e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
          e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
          e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
          e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
          e.$list.off("click.slick", e.clickHandler),
          c(document).off(e.visibilityChange, e.visibility),
          e.cleanUpSlideEvents(),
          !0 === e.options.accessibility &&
            e.$list.off("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().off("click.slick", e.selectHandler),
          c(window).off(
            "orientationchange.slick.slick-" + e.instanceUid,
            e.orientationChange
          ),
          c(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
          c("[draggable!=true]", e.$slideTrack).off(
            "dragstart",
            e.preventDefault
          ),
          c(window).off("load.slick.slick-" + e.instanceUid, e.setPosition);
      }),
      (s.prototype.cleanUpSlideEvents = function () {
        var e = this;
        e.$list.off("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
          e.$list.off("mouseleave.slick", c.proxy(e.interrupt, e, !1));
      }),
      (s.prototype.cleanUpRows = function () {
        var e;
        0 < this.options.rows &&
          ((e = this.$slides.children().children()).removeAttr("style"),
          this.$slider.empty().append(e));
      }),
      (s.prototype.clickHandler = function (e) {
        !1 === this.shouldClick &&
          (e.stopImmediatePropagation(),
          e.stopPropagation(),
          e.preventDefault());
      }),
      (s.prototype.destroy = function (e) {
        var t = this;
        t.autoPlayClear(),
          (t.touchObject = {}),
          t.cleanUpEvents(),
          c(".slick-cloned", t.$slider).detach(),
          t.$dots && t.$dots.remove(),
          t.$prevArrow &&
            t.$prevArrow.length &&
            (t.$prevArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
          t.$nextArrow &&
            t.$nextArrow.length &&
            (t.$nextArrow
              .removeClass("slick-disabled slick-arrow slick-hidden")
              .removeAttr("aria-hidden aria-disabled tabindex")
              .css("display", ""),
            t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
          t.$slides &&
            (t.$slides
              .removeClass(
                "slick-slide slick-active slick-center slick-visible slick-current"
              )
              .removeAttr("aria-hidden")
              .removeAttr("data-slick-index")
              .each(function () {
                c(this).attr("style", c(this).data("originalStyling"));
              }),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slideTrack.detach(),
            t.$list.detach(),
            t.$slider.append(t.$slides)),
          t.cleanUpRows(),
          t.$slider.removeClass("slick-slider"),
          t.$slider.removeClass("slick-initialized"),
          t.$slider.removeClass("slick-dotted"),
          (t.unslicked = !0),
          e || t.$slider.trigger("destroy", [t]);
      }),
      (s.prototype.disableTransition = function (e) {
        var t = {};
        (t[this.transitionType] = ""),
          (!1 === this.options.fade
            ? this.$slideTrack
            : this.$slides.eq(e)
          ).css(t);
      }),
      (s.prototype.fadeSlide = function (e, t) {
        var i = this;
        !1 === i.cssTransitions
          ? (i.$slides.eq(e).css({ zIndex: i.options.zIndex }),
            i.$slides
              .eq(e)
              .animate({ opacity: 1 }, i.options.speed, i.options.easing, t))
          : (i.applyTransition(e),
            i.$slides.eq(e).css({ opacity: 1, zIndex: i.options.zIndex }),
            t &&
              setTimeout(function () {
                i.disableTransition(e), t.call();
              }, i.options.speed));
      }),
      (s.prototype.fadeSlideOut = function (e) {
        var t = this;
        !1 === t.cssTransitions
          ? t.$slides
              .eq(e)
              .animate(
                { opacity: 0, zIndex: t.options.zIndex - 2 },
                t.options.speed,
                t.options.easing
              )
          : (t.applyTransition(e),
            t.$slides.eq(e).css({ opacity: 0, zIndex: t.options.zIndex - 2 }));
      }),
      (s.prototype.filterSlides = s.prototype.slickFilter =
        function (e) {
          var t = this;
          null !== e &&
            ((t.$slidesCache = t.$slides),
            t.unload(),
            t.$slideTrack.children(this.options.slide).detach(),
            t.$slidesCache.filter(e).appendTo(t.$slideTrack),
            t.reinit());
        }),
      (s.prototype.focusHandler = function () {
        var i = this;
        i.$slider
          .off("focus.slick blur.slick")
          .on("focus.slick", "*", function (e) {
            var t = c(this);
            setTimeout(function () {
              i.options.pauseOnFocus &&
                t.is(":focus") &&
                ((i.focussed = !0), i.autoPlay());
            }, 0);
          })
          .on("blur.slick", "*", function (e) {
            c(this);
            i.options.pauseOnFocus && ((i.focussed = !1), i.autoPlay());
          });
      }),
      (s.prototype.getCurrent = s.prototype.slickCurrentSlide =
        function () {
          return this.currentSlide;
        }),
      (s.prototype.getDotCount = function () {
        var e = this,
          t = 0,
          i = 0,
          n = 0;
        if (!0 === e.options.infinite)
          if (e.slideCount <= e.options.slidesToShow) ++n;
          else
            for (; t < e.slideCount; )
              ++n,
                (t = i + e.options.slidesToScroll),
                (i +=
                  e.options.slidesToScroll <= e.options.slidesToShow
                    ? e.options.slidesToScroll
                    : e.options.slidesToShow);
        else if (!0 === e.options.centerMode) n = e.slideCount;
        else if (e.options.asNavFor)
          for (; t < e.slideCount; )
            ++n,
              (t = i + e.options.slidesToScroll),
              (i +=
                e.options.slidesToScroll <= e.options.slidesToShow
                  ? e.options.slidesToScroll
                  : e.options.slidesToShow);
        else
          n =
            1 +
            Math.ceil(
              (e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll
            );
        return n - 1;
      }),
      (s.prototype.getLeft = function (e) {
        var t,
          i,
          n = this,
          o = 0;
        return (
          (n.slideOffset = 0),
          (t = n.$slides.first().outerHeight(!0)),
          !0 === n.options.infinite
            ? (n.slideCount > n.options.slidesToShow &&
                ((n.slideOffset = n.slideWidth * n.options.slidesToShow * -1),
                (i = -1),
                !0 === n.options.vertical &&
                  !0 === n.options.centerMode &&
                  (2 === n.options.slidesToShow
                    ? (i = -1.5)
                    : 1 === n.options.slidesToShow && (i = -2)),
                (o = t * n.options.slidesToShow * i)),
              n.slideCount % n.options.slidesToScroll != 0 &&
                e + n.options.slidesToScroll > n.slideCount &&
                n.slideCount > n.options.slidesToShow &&
                (o =
                  e > n.slideCount
                    ? ((n.slideOffset =
                        (n.options.slidesToShow - (e - n.slideCount)) *
                        n.slideWidth *
                        -1),
                      (n.options.slidesToShow - (e - n.slideCount)) * t * -1)
                    : ((n.slideOffset =
                        (n.slideCount % n.options.slidesToScroll) *
                        n.slideWidth *
                        -1),
                      (n.slideCount % n.options.slidesToScroll) * t * -1)))
            : e + n.options.slidesToShow > n.slideCount &&
              ((n.slideOffset =
                (e + n.options.slidesToShow - n.slideCount) * n.slideWidth),
              (o = (e + n.options.slidesToShow - n.slideCount) * t)),
          n.slideCount <= n.options.slidesToShow && (o = n.slideOffset = 0),
          !0 === n.options.centerMode && n.slideCount <= n.options.slidesToShow
            ? (n.slideOffset =
                (n.slideWidth * Math.floor(n.options.slidesToShow)) / 2 -
                (n.slideWidth * n.slideCount) / 2)
            : !0 === n.options.centerMode && !0 === n.options.infinite
            ? (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2) -
                n.slideWidth)
            : !0 === n.options.centerMode &&
              ((n.slideOffset = 0),
              (n.slideOffset +=
                n.slideWidth * Math.floor(n.options.slidesToShow / 2))),
          (t =
            !1 === n.options.vertical
              ? e * n.slideWidth * -1 + n.slideOffset
              : e * t * -1 + o),
          !0 === n.options.variableWidth &&
            ((o =
              n.slideCount <= n.options.slidesToShow ||
              !1 === n.options.infinite
                ? n.$slideTrack.children(".slick-slide").eq(e)
                : n.$slideTrack
                    .children(".slick-slide")
                    .eq(e + n.options.slidesToShow)),
            (t =
              !0 === n.options.rtl
                ? o[0]
                  ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            !0 === n.options.centerMode &&
              ((o =
                n.slideCount <= n.options.slidesToShow ||
                !1 === n.options.infinite
                  ? n.$slideTrack.children(".slick-slide").eq(e)
                  : n.$slideTrack
                      .children(".slick-slide")
                      .eq(e + n.options.slidesToShow + 1)),
              (t =
                !0 === n.options.rtl
                  ? o[0]
                    ? -1 * (n.$slideTrack.width() - o[0].offsetLeft - o.width())
                    : 0
                  : o[0]
                  ? -1 * o[0].offsetLeft
                  : 0),
              (t += (n.$list.width() - o.outerWidth()) / 2))),
          t
        );
      }),
      (s.prototype.getOption = s.prototype.slickGetOption =
        function (e) {
          return this.options[e];
        }),
      (s.prototype.getNavigableIndexes = function () {
        for (
          var e = this,
            t = 0,
            i = 0,
            n = [],
            o =
              !1 === e.options.infinite
                ? e.slideCount
                : ((t = -1 * e.options.slidesToScroll),
                  (i = -1 * e.options.slidesToScroll),
                  2 * e.slideCount);
          t < o;

        )
          n.push(t),
            (t = i + e.options.slidesToScroll),
            (i +=
              e.options.slidesToScroll <= e.options.slidesToShow
                ? e.options.slidesToScroll
                : e.options.slidesToShow);
        return n;
      }),
      (s.prototype.getSlick = function () {
        return this;
      }),
      (s.prototype.getSlideCount = function () {
        var o,
          r = this,
          e = !0 === r.options.centerMode ? Math.floor(r.$list.width() / 2) : 0,
          s = -1 * r.swipeLeft + e;
        return !0 === r.options.swipeToSlide
          ? (r.$slideTrack.find(".slick-slide").each(function (e, t) {
              var i = c(t).outerWidth(),
                n = t.offsetLeft;
              if ((!0 !== r.options.centerMode && (n += i / 2), s < n + i))
                return (o = t), !1;
            }),
            Math.abs(c(o).attr("data-slick-index") - r.currentSlide) || 1)
          : r.options.slidesToScroll;
      }),
      (s.prototype.goTo = s.prototype.slickGoTo =
        function (e, t) {
          this.changeSlide(
            { data: { message: "index", index: parseInt(e) } },
            t
          );
        }),
      (s.prototype.init = function (e) {
        var t = this;
        c(t.$slider).hasClass("slick-initialized") ||
          (c(t.$slider).addClass("slick-initialized"),
          t.buildRows(),
          t.buildOut(),
          t.setProps(),
          t.startLoad(),
          t.loadSlider(),
          t.initializeEvents(),
          t.updateArrows(),
          t.updateDots(),
          t.checkResponsive(!0),
          t.focusHandler()),
          e && t.$slider.trigger("init", [t]),
          !0 === t.options.accessibility && t.initADA(),
          t.options.autoplay && ((t.paused = !1), t.autoPlay());
      }),
      (s.prototype.initADA = function () {
        var i = this,
          n = Math.ceil(i.slideCount / i.options.slidesToShow),
          o = i.getNavigableIndexes().filter(function (e) {
            return 0 <= e && e < i.slideCount;
          });
        i.$slides
          .add(i.$slideTrack.find(".slick-cloned"))
          .attr({ "aria-hidden": "true", tabindex: "-1" })
          .find("a, input, button, select")
          .attr({ tabindex: "-1" }),
          null !== i.$dots &&
            (i.$slides
              .not(i.$slideTrack.find(".slick-cloned"))
              .each(function (e) {
                var t = o.indexOf(e);
                c(this).attr({
                  role: "tabpanel",
                  id: "slick-slide" + i.instanceUid + e,
                  tabindex: -1,
                }),
                  -1 !== t &&
                    ((t = "slick-slide-control" + i.instanceUid + t),
                    c("#" + t).length &&
                      c(this).attr({ "aria-describedby": t }));
              }),
            i.$dots
              .attr("role", "tablist")
              .find("li")
              .each(function (e) {
                var t = o[e];
                c(this).attr({ role: "presentation" }),
                  c(this)
                    .find("button")
                    .first()
                    .attr({
                      role: "tab",
                      id: "slick-slide-control" + i.instanceUid + e,
                      "aria-controls": "slick-slide" + i.instanceUid + t,
                      "aria-label": e + 1 + " of " + n,
                      "aria-selected": null,
                      tabindex: "-1",
                    });
              })
              .eq(i.currentSlide)
              .find("button")
              .attr({ "aria-selected": "true", tabindex: "0" })
              .end());
        for (var e = i.currentSlide, t = e + i.options.slidesToShow; e < t; e++)
          i.options.focusOnChange
            ? i.$slides.eq(e).attr({ tabindex: "0" })
            : i.$slides.eq(e).removeAttr("tabindex");
        i.activateADA();
      }),
      (s.prototype.initArrowEvents = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow
            .off("click.slick")
            .on("click.slick", { message: "previous" }, e.changeSlide),
          e.$nextArrow
            .off("click.slick")
            .on("click.slick", { message: "next" }, e.changeSlide),
          !0 === e.options.accessibility &&
            (e.$prevArrow.on("keydown.slick", e.keyHandler),
            e.$nextArrow.on("keydown.slick", e.keyHandler)));
      }),
      (s.prototype.initDotEvents = function () {
        var e = this;
        !0 === e.options.dots &&
          e.slideCount > e.options.slidesToShow &&
          (c("li", e.$dots).on(
            "click.slick",
            { message: "index" },
            e.changeSlide
          ),
          !0 === e.options.accessibility &&
            e.$dots.on("keydown.slick", e.keyHandler)),
          !0 === e.options.dots &&
            !0 === e.options.pauseOnDotsHover &&
            e.slideCount > e.options.slidesToShow &&
            c("li", e.$dots)
              .on("mouseenter.slick", c.proxy(e.interrupt, e, !0))
              .on("mouseleave.slick", c.proxy(e.interrupt, e, !1));
      }),
      (s.prototype.initSlideEvents = function () {
        var e = this;
        e.options.pauseOnHover &&
          (e.$list.on("mouseenter.slick", c.proxy(e.interrupt, e, !0)),
          e.$list.on("mouseleave.slick", c.proxy(e.interrupt, e, !1)));
      }),
      (s.prototype.initializeEvents = function () {
        var e = this;
        e.initArrowEvents(),
          e.initDotEvents(),
          e.initSlideEvents(),
          e.$list.on(
            "touchstart.slick mousedown.slick",
            { action: "start" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchmove.slick mousemove.slick",
            { action: "move" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchend.slick mouseup.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on(
            "touchcancel.slick mouseleave.slick",
            { action: "end" },
            e.swipeHandler
          ),
          e.$list.on("click.slick", e.clickHandler),
          c(document).on(e.visibilityChange, c.proxy(e.visibility, e)),
          !0 === e.options.accessibility &&
            e.$list.on("keydown.slick", e.keyHandler),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().on("click.slick", e.selectHandler),
          c(window).on(
            "orientationchange.slick.slick-" + e.instanceUid,
            c.proxy(e.orientationChange, e)
          ),
          c(window).on(
            "resize.slick.slick-" + e.instanceUid,
            c.proxy(e.resize, e)
          ),
          c("[draggable!=true]", e.$slideTrack).on(
            "dragstart",
            e.preventDefault
          ),
          c(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
          c(e.setPosition);
      }),
      (s.prototype.initUI = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.show(), e.$nextArrow.show()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.show();
      }),
      (s.prototype.keyHandler = function (e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
          (37 === e.keyCode && !0 === t.options.accessibility
            ? t.changeSlide({
                data: { message: !0 === t.options.rtl ? "next" : "previous" },
              })
            : 39 === e.keyCode &&
              !0 === t.options.accessibility &&
              t.changeSlide({
                data: { message: !0 === t.options.rtl ? "previous" : "next" },
              }));
      }),
      (s.prototype.lazyLoad = function () {
        var e,
          t,
          i,
          r = this;
        function n(e) {
          c("img[data-lazy]", e).each(function () {
            var e = c(this),
              t = c(this).attr("data-lazy"),
              i = c(this).attr("data-srcset"),
              n = c(this).attr("data-sizes") || r.$slider.attr("data-sizes"),
              o = document.createElement("img");
            (o.onload = function () {
              e.animate({ opacity: 0 }, 100, function () {
                i && (e.attr("srcset", i), n && e.attr("sizes", n)),
                  e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                    e.removeAttr(
                      "data-lazy data-srcset data-sizes"
                    ).removeClass("slick-loading");
                  }),
                  r.$slider.trigger("lazyLoaded", [r, e, t]);
              });
            }),
              (o.onerror = function () {
                e
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, e, t]);
              }),
              (o.src = t);
          });
        }
        if (
          (!0 === r.options.centerMode
            ? (i =
                !0 === r.options.infinite
                  ? (t = r.currentSlide + (r.options.slidesToShow / 2 + 1)) +
                    r.options.slidesToShow +
                    2
                  : ((t = Math.max(
                      0,
                      r.currentSlide - (r.options.slidesToShow / 2 + 1)
                    )),
                    r.options.slidesToShow / 2 + 1 + 2 + r.currentSlide))
            : ((t = r.options.infinite
                ? r.options.slidesToShow + r.currentSlide
                : r.currentSlide),
              (i = Math.ceil(t + r.options.slidesToShow)),
              !0 === r.options.fade &&
                (0 < t && t--, i <= r.slideCount && i++)),
          (e = r.$slider.find(".slick-slide").slice(t, i)),
          "anticipated" === r.options.lazyLoad)
        )
          for (
            var o = t - 1, s = i, a = r.$slider.find(".slick-slide"), l = 0;
            l < r.options.slidesToScroll;
            l++
          )
            o < 0 && (o = r.slideCount - 1),
              (e = (e = e.add(a.eq(o))).add(a.eq(s))),
              o--,
              s++;
        n(e),
          r.slideCount <= r.options.slidesToShow
            ? n(r.$slider.find(".slick-slide"))
            : r.currentSlide >= r.slideCount - r.options.slidesToShow
            ? n(
                r.$slider.find(".slick-cloned").slice(0, r.options.slidesToShow)
              )
            : 0 === r.currentSlide &&
              n(
                r.$slider
                  .find(".slick-cloned")
                  .slice(-1 * r.options.slidesToShow)
              );
      }),
      (s.prototype.loadSlider = function () {
        var e = this;
        e.setPosition(),
          e.$slideTrack.css({ opacity: 1 }),
          e.$slider.removeClass("slick-loading"),
          e.initUI(),
          "progressive" === e.options.lazyLoad && e.progressiveLazyLoad();
      }),
      (s.prototype.next = s.prototype.slickNext =
        function () {
          this.changeSlide({ data: { message: "next" } });
        }),
      (s.prototype.orientationChange = function () {
        this.checkResponsive(), this.setPosition();
      }),
      (s.prototype.pause = s.prototype.slickPause =
        function () {
          this.autoPlayClear(), (this.paused = !0);
        }),
      (s.prototype.play = s.prototype.slickPlay =
        function () {
          var e = this;
          e.autoPlay(),
            (e.options.autoplay = !0),
            (e.paused = !1),
            (e.focussed = !1),
            (e.interrupted = !1);
        }),
      (s.prototype.postSlide = function (e) {
        var t = this;
        t.unslicked ||
          (t.$slider.trigger("afterChange", [t, e]),
          (t.animating = !1),
          t.slideCount > t.options.slidesToShow && t.setPosition(),
          (t.swipeLeft = null),
          t.options.autoplay && t.autoPlay(),
          !0 === t.options.accessibility &&
            (t.initADA(),
            t.options.focusOnChange &&
              c(t.$slides.get(t.currentSlide)).attr("tabindex", 0).focus()));
      }),
      (s.prototype.prev = s.prototype.slickPrev =
        function () {
          this.changeSlide({ data: { message: "previous" } });
        }),
      (s.prototype.preventDefault = function (e) {
        e.preventDefault();
      }),
      (s.prototype.progressiveLazyLoad = function (e) {
        e = e || 1;
        var t,
          i,
          n,
          o,
          r = this,
          s = c("img[data-lazy]", r.$slider);
        s.length
          ? ((t = s.first()),
            (i = t.attr("data-lazy")),
            (n = t.attr("data-srcset")),
            (o = t.attr("data-sizes") || r.$slider.attr("data-sizes")),
            ((s = document.createElement("img")).onload = function () {
              n && (t.attr("srcset", n), o && t.attr("sizes", o)),
                t
                  .attr("src", i)
                  .removeAttr("data-lazy data-srcset data-sizes")
                  .removeClass("slick-loading"),
                !0 === r.options.adaptiveHeight && r.setPosition(),
                r.$slider.trigger("lazyLoaded", [r, t, i]),
                r.progressiveLazyLoad();
            }),
            (s.onerror = function () {
              e < 3
                ? setTimeout(function () {
                    r.progressiveLazyLoad(e + 1);
                  }, 500)
                : (t
                    .removeAttr("data-lazy")
                    .removeClass("slick-loading")
                    .addClass("slick-lazyload-error"),
                  r.$slider.trigger("lazyLoadError", [r, t, i]),
                  r.progressiveLazyLoad());
            }),
            (s.src = i))
          : r.$slider.trigger("allImagesLoaded", [r]);
      }),
      (s.prototype.refresh = function (e) {
        var t = this,
          i = t.slideCount - t.options.slidesToShow;
        !t.options.infinite && t.currentSlide > i && (t.currentSlide = i),
          t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
          (i = t.currentSlide),
          t.destroy(!0),
          c.extend(t, t.initials, { currentSlide: i }),
          t.init(),
          e || t.changeSlide({ data: { message: "index", index: i } }, !1);
      }),
      (s.prototype.registerBreakpoints = function () {
        var e,
          t,
          i,
          n = this,
          o = n.options.responsive || null;
        if ("array" === c.type(o) && o.length) {
          for (e in ((n.respondTo = n.options.respondTo || "window"), o))
            if (((i = n.breakpoints.length - 1), o.hasOwnProperty(e))) {
              for (t = o[e].breakpoint; 0 <= i; )
                n.breakpoints[i] &&
                  n.breakpoints[i] === t &&
                  n.breakpoints.splice(i, 1),
                  i--;
              n.breakpoints.push(t), (n.breakpointSettings[t] = o[e].settings);
            }
          n.breakpoints.sort(function (e, t) {
            return n.options.mobileFirst ? e - t : t - e;
          });
        }
      }),
      (s.prototype.reinit = function () {
        var e = this;
        (e.$slides = e.$slideTrack
          .children(e.options.slide)
          .addClass("slick-slide")),
          (e.slideCount = e.$slides.length),
          e.currentSlide >= e.slideCount &&
            0 !== e.currentSlide &&
            (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
          e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
          e.registerBreakpoints(),
          e.setProps(),
          e.setupInfinite(),
          e.buildArrows(),
          e.updateArrows(),
          e.initArrowEvents(),
          e.buildDots(),
          e.updateDots(),
          e.initDotEvents(),
          e.cleanUpSlideEvents(),
          e.initSlideEvents(),
          e.checkResponsive(!1, !0),
          !0 === e.options.focusOnSelect &&
            c(e.$slideTrack).children().on("click.slick", e.selectHandler),
          e.setSlideClasses(
            "number" == typeof e.currentSlide ? e.currentSlide : 0
          ),
          e.setPosition(),
          e.focusHandler(),
          (e.paused = !e.options.autoplay),
          e.autoPlay(),
          e.$slider.trigger("reInit", [e]);
      }),
      (s.prototype.resize = function () {
        var e = this;
        c(window).width() !== e.windowWidth &&
          (clearTimeout(e.windowDelay),
          (e.windowDelay = window.setTimeout(function () {
            (e.windowWidth = c(window).width()),
              e.checkResponsive(),
              e.unslicked || e.setPosition();
          }, 50)));
      }),
      (s.prototype.removeSlide = s.prototype.slickRemove =
        function (e, t, i) {
          var n = this;
          if (
            ((e =
              "boolean" == typeof e
                ? !0 === (t = e)
                  ? 0
                  : n.slideCount - 1
                : !0 === t
                ? --e
                : e),
            n.slideCount < 1 || e < 0 || e > n.slideCount - 1)
          )
            return !1;
          n.unload(),
            (!0 === i
              ? n.$slideTrack.children()
              : n.$slideTrack.children(this.options.slide).eq(e)
            ).remove(),
            (n.$slides = n.$slideTrack.children(this.options.slide)),
            n.$slideTrack.children(this.options.slide).detach(),
            n.$slideTrack.append(n.$slides),
            (n.$slidesCache = n.$slides),
            n.reinit();
        }),
      (s.prototype.setCSS = function (e) {
        var t,
          i,
          n = this,
          o = {};
        !0 === n.options.rtl && (e = -e),
          (t = "left" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (i = "top" == n.positionProp ? Math.ceil(e) + "px" : "0px"),
          (o[n.positionProp] = e),
          !1 === n.transformsEnabled ||
            (!(o = {}) === n.cssTransitions
              ? (o[n.animType] = "translate(" + t + ", " + i + ")")
              : (o[n.animType] = "translate3d(" + t + ", " + i + ", 0px)")),
          n.$slideTrack.css(o);
      }),
      (s.prototype.setDimensions = function () {
        var e = this;
        !1 === e.options.vertical
          ? !0 === e.options.centerMode &&
            e.$list.css({ padding: "0px " + e.options.centerPadding })
          : (e.$list.height(
              e.$slides.first().outerHeight(!0) * e.options.slidesToShow
            ),
            !0 === e.options.centerMode &&
              e.$list.css({ padding: e.options.centerPadding + " 0px" })),
          (e.listWidth = e.$list.width()),
          (e.listHeight = e.$list.height()),
          !1 === e.options.vertical && !1 === e.options.variableWidth
            ? ((e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow)),
              e.$slideTrack.width(
                Math.ceil(
                  e.slideWidth * e.$slideTrack.children(".slick-slide").length
                )
              ))
            : !0 === e.options.variableWidth
            ? e.$slideTrack.width(5e3 * e.slideCount)
            : ((e.slideWidth = Math.ceil(e.listWidth)),
              e.$slideTrack.height(
                Math.ceil(
                  e.$slides.first().outerHeight(!0) *
                    e.$slideTrack.children(".slick-slide").length
                )
              ));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth &&
          e.$slideTrack.children(".slick-slide").width(e.slideWidth - t);
      }),
      (s.prototype.setFade = function () {
        var i,
          n = this;
        n.$slides.each(function (e, t) {
          (i = n.slideWidth * e * -1),
            !0 === n.options.rtl
              ? c(t).css({
                  position: "relative",
                  right: i,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                })
              : c(t).css({
                  position: "relative",
                  left: i,
                  top: 0,
                  zIndex: n.options.zIndex - 2,
                  opacity: 0,
                });
        }),
          n.$slides
            .eq(n.currentSlide)
            .css({ zIndex: n.options.zIndex - 1, opacity: 1 });
      }),
      (s.prototype.setHeight = function () {
        var e,
          t = this;
        1 === t.options.slidesToShow &&
          !0 === t.options.adaptiveHeight &&
          !1 === t.options.vertical &&
          ((e = t.$slides.eq(t.currentSlide).outerHeight(!0)),
          t.$list.css("height", e));
      }),
      (s.prototype.setOption = s.prototype.slickSetOption =
        function () {
          var e,
            t,
            i,
            n,
            o,
            r = this,
            s = !1;
          if (
            ("object" === c.type(arguments[0])
              ? ((i = arguments[0]), (s = arguments[1]), (o = "multiple"))
              : "string" === c.type(arguments[0]) &&
                ((i = arguments[0]),
                (n = arguments[1]),
                (s = arguments[2]),
                "responsive" === arguments[0] &&
                "array" === c.type(arguments[1])
                  ? (o = "responsive")
                  : void 0 !== arguments[1] && (o = "single")),
            "single" === o)
          )
            r.options[i] = n;
          else if ("multiple" === o)
            c.each(i, function (e, t) {
              r.options[e] = t;
            });
          else if ("responsive" === o)
            for (t in n)
              if ("array" !== c.type(r.options.responsive))
                r.options.responsive = [n[t]];
              else {
                for (e = r.options.responsive.length - 1; 0 <= e; )
                  r.options.responsive[e].breakpoint === n[t].breakpoint &&
                    r.options.responsive.splice(e, 1),
                    e--;
                r.options.responsive.push(n[t]);
              }
          s && (r.unload(), r.reinit());
        }),
      (s.prototype.setPosition = function () {
        var e = this;
        e.setDimensions(),
          e.setHeight(),
          !1 === e.options.fade
            ? e.setCSS(e.getLeft(e.currentSlide))
            : e.setFade(),
          e.$slider.trigger("setPosition", [e]);
      }),
      (s.prototype.setProps = function () {
        var e = this,
          t = document.body.style;
        (e.positionProp = !0 === e.options.vertical ? "top" : "left"),
          "top" === e.positionProp
            ? e.$slider.addClass("slick-vertical")
            : e.$slider.removeClass("slick-vertical"),
          (void 0 === t.WebkitTransition &&
            void 0 === t.MozTransition &&
            void 0 === t.msTransition) ||
            (!0 === e.options.useCSS && (e.cssTransitions = !0)),
          e.options.fade &&
            ("number" == typeof e.options.zIndex
              ? e.options.zIndex < 3 && (e.options.zIndex = 3)
              : (e.options.zIndex = e.defaults.zIndex)),
          void 0 !== t.OTransform &&
            ((e.animType = "OTransform"),
            (e.transformType = "-o-transform"),
            (e.transitionType = "OTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.MozTransform &&
            ((e.animType = "MozTransform"),
            (e.transformType = "-moz-transform"),
            (e.transitionType = "MozTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.MozPerspective &&
              (e.animType = !1)),
          void 0 !== t.webkitTransform &&
            ((e.animType = "webkitTransform"),
            (e.transformType = "-webkit-transform"),
            (e.transitionType = "webkitTransition"),
            void 0 === t.perspectiveProperty &&
              void 0 === t.webkitPerspective &&
              (e.animType = !1)),
          void 0 !== t.msTransform &&
            ((e.animType = "msTransform"),
            (e.transformType = "-ms-transform"),
            (e.transitionType = "msTransition"),
            void 0 === t.msTransform && (e.animType = !1)),
          void 0 !== t.transform &&
            !1 !== e.animType &&
            ((e.animType = "transform"),
            (e.transformType = "transform"),
            (e.transitionType = "transition")),
          (e.transformsEnabled =
            e.options.useTransform && null !== e.animType && !1 !== e.animType);
      }),
      (s.prototype.setSlideClasses = function (e) {
        var t,
          i,
          n,
          o = this,
          r = o.$slider
            .find(".slick-slide")
            .removeClass("slick-active slick-center slick-current")
            .attr("aria-hidden", "true");
        o.$slides.eq(e).addClass("slick-current"),
          !0 === o.options.centerMode
            ? ((i = o.options.slidesToShow % 2 == 0 ? 1 : 0),
              (n = Math.floor(o.options.slidesToShow / 2)),
              !0 === o.options.infinite &&
                (n <= e && e <= o.slideCount - 1 - n
                  ? o.$slides
                      .slice(e - n + i, e + n + 1)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")
                  : ((t = o.options.slidesToShow + e),
                    r
                      .slice(t - n + 1 + i, t + n + 2)
                      .addClass("slick-active")
                      .attr("aria-hidden", "false")),
                0 === e
                  ? r
                      .eq(r.length - 1 - o.options.slidesToShow)
                      .addClass("slick-center")
                  : e === o.slideCount - 1 &&
                    r.eq(o.options.slidesToShow).addClass("slick-center")),
              o.$slides.eq(e).addClass("slick-center"))
            : 0 <= e && e <= o.slideCount - o.options.slidesToShow
            ? o.$slides
                .slice(e, e + o.options.slidesToShow)
                .addClass("slick-active")
                .attr("aria-hidden", "false")
            : r.length <= o.options.slidesToShow
            ? r.addClass("slick-active").attr("aria-hidden", "false")
            : ((n = o.slideCount % o.options.slidesToShow),
              (t = !0 === o.options.infinite ? o.options.slidesToShow + e : e),
              (o.options.slidesToShow == o.options.slidesToScroll &&
              o.slideCount - e < o.options.slidesToShow
                ? r.slice(t - (o.options.slidesToShow - n), t + n)
                : r.slice(t, t + o.options.slidesToShow)
              )
                .addClass("slick-active")
                .attr("aria-hidden", "false")),
          ("ondemand" !== o.options.lazyLoad &&
            "anticipated" !== o.options.lazyLoad) ||
            o.lazyLoad();
      }),
      (s.prototype.setupInfinite = function () {
        var e,
          t,
          i,
          n = this;
        if (
          (!0 === n.options.fade && (n.options.centerMode = !1),
          !0 === n.options.infinite &&
            !1 === n.options.fade &&
            ((t = null), n.slideCount > n.options.slidesToShow))
        ) {
          for (
            i =
              !0 === n.options.centerMode
                ? n.options.slidesToShow + 1
                : n.options.slidesToShow,
              e = n.slideCount;
            e > n.slideCount - i;
            --e
          )
            c(n.$slides[(t = e - 1)])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - n.slideCount)
              .prependTo(n.$slideTrack)
              .addClass("slick-cloned");
          for (e = 0; e < i + n.slideCount; e += 1)
            (t = e),
              c(n.$slides[t])
                .clone(!0)
                .attr("id", "")
                .attr("data-slick-index", t + n.slideCount)
                .appendTo(n.$slideTrack)
                .addClass("slick-cloned");
          n.$slideTrack
            .find(".slick-cloned")
            .find("[id]")
            .each(function () {
              c(this).attr("id", "");
            });
        }
      }),
      (s.prototype.interrupt = function (e) {
        e || this.autoPlay(), (this.interrupted = e);
      }),
      (s.prototype.selectHandler = function (e) {
        (e = c(e.target).is(".slick-slide")
          ? c(e.target)
          : c(e.target).parents(".slick-slide")),
          (e = parseInt(e.attr("data-slick-index")) || 0);
        this.slideCount <= this.options.slidesToShow
          ? this.slideHandler(e, !1, !0)
          : this.slideHandler(e);
      }),
      (s.prototype.slideHandler = function (e, t, i) {
        var n,
          o,
          r,
          s,
          a = this;
        if (
          ((t = t || !1),
          !(
            (!0 === a.animating && !0 === a.options.waitForAnimate) ||
            (!0 === a.options.fade && a.currentSlide === e)
          ))
        )
          if (
            (!1 === t && a.asNavFor(e),
            (n = e),
            (r = a.getLeft(n)),
            (t = a.getLeft(a.currentSlide)),
            (a.currentLeft = null === a.swipeLeft ? t : a.swipeLeft),
            !1 === a.options.infinite &&
              !1 === a.options.centerMode &&
              (e < 0 || e > a.getDotCount() * a.options.slidesToScroll))
          )
            !1 === a.options.fade &&
              ((n = a.currentSlide),
              !0 !== i && a.slideCount > a.options.slidesToShow
                ? a.animateSlide(t, function () {
                    a.postSlide(n);
                  })
                : a.postSlide(n));
          else if (
            !1 === a.options.infinite &&
            !0 === a.options.centerMode &&
            (e < 0 || e > a.slideCount - a.options.slidesToScroll)
          )
            !1 === a.options.fade &&
              ((n = a.currentSlide),
              !0 !== i && a.slideCount > a.options.slidesToShow
                ? a.animateSlide(t, function () {
                    a.postSlide(n);
                  })
                : a.postSlide(n));
          else {
            if (
              (a.options.autoplay && clearInterval(a.autoPlayTimer),
              (o =
                n < 0
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                    : a.slideCount + n
                  : n >= a.slideCount
                  ? a.slideCount % a.options.slidesToScroll != 0
                    ? 0
                    : n - a.slideCount
                  : n),
              (a.animating = !0),
              a.$slider.trigger("beforeChange", [a, a.currentSlide, o]),
              (t = a.currentSlide),
              (a.currentSlide = o),
              a.setSlideClasses(a.currentSlide),
              a.options.asNavFor &&
                (s = (s = a.getNavTarget()).slick("getSlick")).slideCount <=
                  s.options.slidesToShow &&
                s.setSlideClasses(a.currentSlide),
              a.updateDots(),
              a.updateArrows(),
              !0 === a.options.fade)
            )
              return (
                !0 !== i
                  ? (a.fadeSlideOut(t),
                    a.fadeSlide(o, function () {
                      a.postSlide(o);
                    }))
                  : a.postSlide(o),
                void a.animateHeight()
              );
            !0 !== i && a.slideCount > a.options.slidesToShow
              ? a.animateSlide(r, function () {
                  a.postSlide(o);
                })
              : a.postSlide(o);
          }
      }),
      (s.prototype.startLoad = function () {
        var e = this;
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow.hide(), e.$nextArrow.hide()),
          !0 === e.options.dots &&
            e.slideCount > e.options.slidesToShow &&
            e.$dots.hide(),
          e.$slider.addClass("slick-loading");
      }),
      (s.prototype.swipeDirection = function () {
        var e = this,
          t = e.touchObject.startX - e.touchObject.curX,
          i = e.touchObject.startY - e.touchObject.curY,
          t = Math.atan2(i, t),
          t = Math.round((180 * t) / Math.PI);
        return ((t = t < 0 ? 360 - Math.abs(t) : t) <= 45 && 0 <= t) ||
          (t <= 360 && 315 <= t)
          ? !1 === e.options.rtl
            ? "left"
            : "right"
          : 135 <= t && t <= 225
          ? !1 === e.options.rtl
            ? "right"
            : "left"
          : !0 === e.options.verticalSwiping
          ? 35 <= t && t <= 135
            ? "down"
            : "up"
          : "vertical";
      }),
      (s.prototype.swipeEnd = function (e) {
        var t,
          i,
          n = this;
        if (((n.dragging = !1), (n.swiping = !1), n.scrolling))
          return (n.scrolling = !1);
        if (
          ((n.interrupted = !1),
          (n.shouldClick = !(10 < n.touchObject.swipeLength)),
          void 0 === n.touchObject.curX)
        )
          return !1;
        if (
          (!0 === n.touchObject.edgeHit &&
            n.$slider.trigger("edge", [n, n.swipeDirection()]),
          n.touchObject.swipeLength >= n.touchObject.minSwipe)
        ) {
          switch ((i = n.swipeDirection())) {
            case "left":
            case "down":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide + n.getSlideCount())
                : n.currentSlide + n.getSlideCount()),
                (n.currentDirection = 0);
              break;
            case "right":
            case "up":
              (t = n.options.swipeToSlide
                ? n.checkNavigable(n.currentSlide - n.getSlideCount())
                : n.currentSlide - n.getSlideCount()),
                (n.currentDirection = 1);
          }
          "vertical" != i &&
            (n.slideHandler(t),
            (n.touchObject = {}),
            n.$slider.trigger("swipe", [n, i]));
        } else
          n.touchObject.startX !== n.touchObject.curX &&
            (n.slideHandler(n.currentSlide), (n.touchObject = {}));
      }),
      (s.prototype.swipeHandler = function (e) {
        var t = this;
        if (
          !(
            !1 === t.options.swipe ||
            ("ontouchend" in document && !1 === t.options.swipe) ||
            (!1 === t.options.draggable && -1 !== e.type.indexOf("mouse"))
          )
        )
          switch (
            ((t.touchObject.fingerCount =
              e.originalEvent && void 0 !== e.originalEvent.touches
                ? e.originalEvent.touches.length
                : 1),
            (t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold),
            !0 === t.options.verticalSwiping &&
              (t.touchObject.minSwipe =
                t.listHeight / t.options.touchThreshold),
            e.data.action)
          ) {
            case "start":
              t.swipeStart(e);
              break;
            case "move":
              t.swipeMove(e);
              break;
            case "end":
              t.swipeEnd(e);
          }
      }),
      (s.prototype.swipeMove = function (e) {
        var t,
          i,
          n = this,
          o = void 0 !== e.originalEvent ? e.originalEvent.touches : null;
        return (
          !(!n.dragging || n.scrolling || (o && 1 !== o.length)) &&
          ((t = n.getLeft(n.currentSlide)),
          (n.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX),
          (n.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY),
          (n.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(n.touchObject.curX - n.touchObject.startX, 2))
          )),
          (i = Math.round(
            Math.sqrt(Math.pow(n.touchObject.curY - n.touchObject.startY, 2))
          )),
          !n.options.verticalSwiping && !n.swiping && 4 < i
            ? !(n.scrolling = !0)
            : (!0 === n.options.verticalSwiping &&
                (n.touchObject.swipeLength = i),
              (o = n.swipeDirection()),
              void 0 !== e.originalEvent &&
                4 < n.touchObject.swipeLength &&
                ((n.swiping = !0), e.preventDefault()),
              (i =
                (!1 === n.options.rtl ? 1 : -1) *
                (n.touchObject.curX > n.touchObject.startX ? 1 : -1)),
              !0 === n.options.verticalSwiping &&
                (i = n.touchObject.curY > n.touchObject.startY ? 1 : -1),
              (e = n.touchObject.swipeLength),
              (n.touchObject.edgeHit = !1) === n.options.infinite &&
                ((0 === n.currentSlide && "right" === o) ||
                  (n.currentSlide >= n.getDotCount() && "left" === o)) &&
                ((e = n.touchObject.swipeLength * n.options.edgeFriction),
                (n.touchObject.edgeHit = !0)),
              !1 === n.options.vertical
                ? (n.swipeLeft = t + e * i)
                : (n.swipeLeft = t + e * (n.$list.height() / n.listWidth) * i),
              !0 === n.options.verticalSwiping && (n.swipeLeft = t + e * i),
              !0 !== n.options.fade &&
                !1 !== n.options.touchMove &&
                (!0 === n.animating
                  ? ((n.swipeLeft = null), !1)
                  : void n.setCSS(n.swipeLeft))))
        );
      }),
      (s.prototype.swipeStart = function (e) {
        var t,
          i = this;
        if (
          ((i.interrupted = !0),
          1 !== i.touchObject.fingerCount ||
            i.slideCount <= i.options.slidesToShow)
        )
          return !(i.touchObject = {});
        void 0 !== e.originalEvent &&
          void 0 !== e.originalEvent.touches &&
          (t = e.originalEvent.touches[0]),
          (i.touchObject.startX = i.touchObject.curX =
            void 0 !== t ? t.pageX : e.clientX),
          (i.touchObject.startY = i.touchObject.curY =
            void 0 !== t ? t.pageY : e.clientY),
          (i.dragging = !0);
      }),
      (s.prototype.unfilterSlides = s.prototype.slickUnfilter =
        function () {
          var e = this;
          null !== e.$slidesCache &&
            (e.unload(),
            e.$slideTrack.children(this.options.slide).detach(),
            e.$slidesCache.appendTo(e.$slideTrack),
            e.reinit());
        }),
      (s.prototype.unload = function () {
        var e = this;
        c(".slick-cloned", e.$slider).remove(),
          e.$dots && e.$dots.remove(),
          e.$prevArrow &&
            e.htmlExpr.test(e.options.prevArrow) &&
            e.$prevArrow.remove(),
          e.$nextArrow &&
            e.htmlExpr.test(e.options.nextArrow) &&
            e.$nextArrow.remove(),
          e.$slides
            .removeClass("slick-slide slick-active slick-visible slick-current")
            .attr("aria-hidden", "true")
            .css("width", "");
      }),
      (s.prototype.unslick = function (e) {
        this.$slider.trigger("unslick", [this, e]), this.destroy();
      }),
      (s.prototype.updateArrows = function () {
        var e = this;
        Math.floor(e.options.slidesToShow / 2);
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          !e.options.infinite &&
          (e.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          e.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === e.currentSlide
            ? (e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              e.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : ((e.currentSlide >= e.slideCount - e.options.slidesToShow &&
                !1 === e.options.centerMode) ||
                (e.currentSlide >= e.slideCount - 1 &&
                  !0 === e.options.centerMode)) &&
              (e.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              e.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
      }),
      (s.prototype.updateDots = function () {
        var e = this;
        null !== e.$dots &&
          (e.$dots.find("li").removeClass("slick-active").end(),
          e.$dots
            .find("li")
            .eq(Math.floor(e.currentSlide / e.options.slidesToScroll))
            .addClass("slick-active"));
      }),
      (s.prototype.visibility = function () {
        this.options.autoplay &&
          (document[this.hidden]
            ? (this.interrupted = !0)
            : (this.interrupted = !1));
      }),
      (c.fn.slick = function () {
        for (
          var e,
            t = this,
            i = arguments[0],
            n = Array.prototype.slice.call(arguments, 1),
            o = t.length,
            r = 0;
          r < o;
          r++
        )
          if (
            ("object" == typeof i || void 0 === i
              ? (t[r].slick = new s(t[r], i))
              : (e = t[r].slick[i].apply(t[r].slick, n)),
            void 0 !== e)
          )
            return e;
        return t;
      });
  }),
  (function (e) {
    "function" == typeof define && define.amd
      ? define(["jquery"], e)
      : "object" == typeof module && module.exports
      ? (module.exports = e(require("jquery")))
      : e(jQuery);
  })(function (d) {
    function e() {
      for (
        var e = u.scrollTop(),
          t = p.height(),
          i = t - h,
          n = i < e ? i - e : 0,
          o = 0,
          r = f.length;
        o < r;
        o++
      ) {
        var s,
          a,
          l = f[o],
          c = l.stickyWrapper.offset().top - l.topSpacing - n;
        l.stickyWrapper.css("height", l.stickyElement.outerHeight()),
          e <= c
            ? null !== l.currentTop &&
              (l.stickyElement.css({
                width: "",
                position: "",
                top: "",
                "z-index": "",
              }),
              l.stickyElement.parent().removeClass(l.className),
              l.stickyElement.trigger("sticky-end", [l]),
              (l.currentTop = null))
            : ((s =
                t -
                l.stickyElement.outerHeight() -
                l.topSpacing -
                l.bottomSpacing -
                e -
                n) < 0
                ? (s += l.topSpacing)
                : (s = l.topSpacing),
              l.currentTop !== s &&
                (l.getWidthFrom
                  ? (a = d(l.getWidthFrom).width() || null)
                  : l.widthFromWrapper && (a = l.stickyWrapper.width()),
                null == a && (a = l.stickyElement.width()),
                l.stickyElement
                  .css("width", a)
                  .css("position", "fixed")
                  .css("top", s)
                  .css("z-index", l.zIndex),
                l.stickyElement.parent().addClass(l.className),
                null === l.currentTop
                  ? l.stickyElement.trigger("sticky-start", [l])
                  : l.stickyElement.trigger("sticky-update", [l]),
                (l.currentTop === l.topSpacing && l.currentTop > s) ||
                (null === l.currentTop && s < l.topSpacing)
                  ? l.stickyElement.trigger("sticky-bottom-reached", [l])
                  : null !== l.currentTop &&
                    s === l.topSpacing &&
                    l.currentTop < s &&
                    l.stickyElement.trigger("sticky-bottom-unreached", [l]),
                (l.currentTop = s)),
              (c = l.stickyWrapper.parent()),
              l.stickyElement.offset().top + l.stickyElement.outerHeight() >=
                c.offset().top + c.outerHeight() &&
              l.stickyElement.offset().top <= l.topSpacing
                ? l.stickyElement
                    .css("position", "absolute")
                    .css("top", "")
                    .css("bottom", 0)
                    .css("z-index", "")
                : l.stickyElement
                    .css("position", "fixed")
                    .css("top", s)
                    .css("bottom", "")
                    .css("z-index", l.zIndex));
      }
    }
    function t() {
      h = u.height();
      for (var e = 0, t = f.length; e < t; e++) {
        var i = f[e],
          n = null;
        i.getWidthFrom
          ? i.responsiveWidth && (n = d(i.getWidthFrom).width())
          : i.widthFromWrapper && (n = i.stickyWrapper.width()),
          null != n && i.stickyElement.css("width", n);
      }
    }
    var i = Array.prototype.slice,
      n = Array.prototype.splice,
      s = {
        topSpacing: 0,
        bottomSpacing: 0,
        className: "is-sticky",
        wrapperClassName: "sticky-wrapper",
        center: !1,
        getWidthFrom: "",
        widthFromWrapper: !0,
        responsiveWidth: !1,
        zIndex: "auto",
      },
      u = d(window),
      p = d(document),
      f = [],
      h = u.height(),
      a = {
        init: function (r) {
          return this.each(function () {
            var e = d.extend({}, s, r),
              t = d(this),
              i = t.attr("id"),
              n = i ? i + "-" + s.wrapperClassName : s.wrapperClassName,
              o = d("<div></div>").attr("id", n).addClass(e.wrapperClassName);
            t.wrapAll(function () {
              if (0 == d(this).parent("#" + n).length) return o;
            });
            i = t.parent();
            e.center &&
              i.css({
                width: t.outerWidth(),
                marginLeft: "auto",
                marginRight: "auto",
              }),
              "right" === t.css("float") &&
                t.css({ float: "none" }).parent().css({ float: "right" }),
              (e.stickyElement = t),
              (e.stickyWrapper = i),
              (e.currentTop = null),
              f.push(e),
              a.setWrapperHeight(this),
              a.setupChangeListeners(this);
          });
        },
        setWrapperHeight: function (e) {
          var t = d(e),
            e = t.parent();
          e && e.css("height", t.outerHeight());
        },
        setupChangeListeners: function (t) {
          window.MutationObserver
            ? new window.MutationObserver(function (e) {
                (e[0].addedNodes.length || e[0].removedNodes.length) &&
                  a.setWrapperHeight(t);
              }).observe(t, { subtree: !0, childList: !0 })
            : window.addEventListener
            ? (t.addEventListener(
                "DOMNodeInserted",
                function () {
                  a.setWrapperHeight(t);
                },
                !1
              ),
              t.addEventListener(
                "DOMNodeRemoved",
                function () {
                  a.setWrapperHeight(t);
                },
                !1
              ))
            : window.attachEvent &&
              (t.attachEvent("onDOMNodeInserted", function () {
                a.setWrapperHeight(t);
              }),
              t.attachEvent("onDOMNodeRemoved", function () {
                a.setWrapperHeight(t);
              }));
        },
        update: e,
        unstick: function (e) {
          return this.each(function () {
            for (var e = d(this), t = -1, i = f.length; 0 < i--; )
              f[i].stickyElement.get(0) === this && (n.call(f, i, 1), (t = i));
            -1 !== t &&
              (e.unwrap(),
              e.css({
                width: "",
                position: "",
                top: "",
                float: "",
                "z-index": "",
              }));
          });
        },
      };
    window.addEventListener
      ? (window.addEventListener("scroll", e, !1),
        window.addEventListener("resize", t, !1))
      : window.attachEvent &&
        (window.attachEvent("onscroll", e), window.attachEvent("onresize", t)),
      (d.fn.sticky = function (e) {
        return a[e]
          ? a[e].apply(this, i.call(arguments, 1))
          : "object" != typeof e && e
          ? void d.error("Method " + e + " does not exist on jQuery.sticky")
          : a.init.apply(this, arguments);
      }),
      (d.fn.unstick = function (e) {
        return a[e]
          ? a[e].apply(this, i.call(arguments, 1))
          : "object" != typeof e && e
          ? void d.error("Method " + e + " does not exist on jQuery.sticky")
          : a.unstick.apply(this, arguments);
      }),
      d(function () {
        setTimeout(e, 0);
      });
  }),
  function () {
    var z = this.jQuery || window.jQuery,
      D = z(window);
    z.fn.stick_in_parent = function (e) {
      var k,
        t,
        i,
        n,
        x = (e = null == e ? {} : e).sticky_class,
        T = e.inner_scrolling,
        C = e.recalc_every,
        S = e.parent,
        A = e.offset_top,
        E = e.spacer,
        $ = e.bottoming;
      for (
        null == A && (A = 0),
          null == S && (S = void 0),
          null == T && (T = !0),
          null == x && (x = "is_stuck"),
          k = z(document),
          null == $ && ($ = !0),
          t = function (o, r, s, a, l, c, d, u) {
            var p, e, f, h, g, v, m, y, t, w, b, n;
            if (!o.data("sticky_kit")) {
              if (
                (o.data("sticky_kit", !0),
                (g = k.height()),
                (m = o.parent()),
                !(m = null != S ? m.closest(S) : m).length)
              )
                throw "failed to find stick parent";
              if (
                ((p = f = !1),
                (b = null != E ? E && o.closest(E) : z("<div />")) &&
                  b.css("position", o.css("position")),
                (y = function () {
                  var e, t, i;
                  if (
                    !u &&
                    ((g = k.height()),
                    (e = parseInt(m.css("border-top-width"), 10)),
                    (t = parseInt(m.css("padding-top"), 10)),
                    (r = parseInt(m.css("padding-bottom"), 10)),
                    (s = m.offset().top + e + t),
                    (a = m.height()),
                    f &&
                      ((p = f = !1),
                      null == E && (o.insertAfter(b), b.detach()),
                      o
                        .css({ position: "", top: "", width: "", bottom: "" })
                        .removeClass(x),
                      (i = !0)),
                    (l =
                      o.offset().top -
                      (parseInt(o.css("margin-top"), 10) || 0) -
                      A),
                    (c = o.outerHeight(!0)),
                    (d = o.css("float")),
                    b &&
                      b.css({
                        width: o.outerWidth(!0),
                        height: c,
                        display: o.css("display"),
                        "vertical-align": o.css("vertical-align"),
                        float: d,
                      }),
                    i)
                  )
                    return n();
                })(),
                c !== a)
              )
                return (
                  (h = void 0),
                  (v = A),
                  (w = C),
                  (n = function () {
                    var e, t, i, n;
                    if (
                      !u &&
                      ((i = !1),
                      null != w && --w <= 0 && ((w = C), y(), (i = !0)),
                      i || k.height() === g || y(),
                      (i = D.scrollTop()),
                      null != h && (t = i - h),
                      (h = i),
                      f
                        ? ($ &&
                            ((n = a + s < i + c + v),
                            p &&
                              !n &&
                              ((p = !1),
                              o
                                .css({ position: "fixed", bottom: "", top: v })
                                .trigger("sticky_kit:unbottom"))),
                          i < l &&
                            ((f = !1),
                            (v = A),
                            null == E &&
                              (("left" !== d && "right" !== d) ||
                                o.insertAfter(b),
                              b.detach()),
                            o
                              .css((e = { position: "", width: "", top: "" }))
                              .removeClass(x)
                              .trigger("sticky_kit:unstick")),
                          T &&
                            (e = D.height()) < c + A &&
                            !p &&
                            ((v -= t),
                            (v = Math.max(e - c, v)),
                            (v = Math.min(A, v)),
                            f && o.css({ top: v + "px" })))
                        : l < i &&
                          ((f = !0),
                          ((e = { position: "fixed", top: v }).width =
                            "border-box" === o.css("box-sizing")
                              ? o.outerWidth() + "px"
                              : o.width() + "px"),
                          o.css(e).addClass(x),
                          null == E &&
                            (o.after(b),
                            ("left" !== d && "right" !== d) || b.append(o)),
                          o.trigger("sticky_kit:stick")),
                      f && $ && (null == n && (n = a + s < i + c + v), !p && n))
                    )
                      return (
                        (p = !0),
                        "static" === m.css("position") &&
                          m.css({ position: "relative" }),
                        o
                          .css({ position: "absolute", bottom: r, top: "auto" })
                          .trigger("sticky_kit:bottom")
                      );
                  }),
                  (t = function () {
                    return y(), n();
                  }),
                  (e = function () {
                    if (
                      ((u = !0),
                      D.off("touchmove", n),
                      D.off("scroll", n),
                      D.off("resize", t),
                      z(document.body).off("sticky_kit:recalc", t),
                      o.off("sticky_kit:detach", e),
                      o.removeData("sticky_kit"),
                      o.css({ position: "", bottom: "", top: "", width: "" }),
                      m.position("position", ""),
                      f)
                    )
                      return (
                        null == E &&
                          (("left" !== d && "right" !== d) || o.insertAfter(b),
                          b.remove()),
                        o.removeClass(x)
                      );
                  }),
                  D.on("touchmove", n),
                  D.on("scroll", n),
                  D.on("resize", t),
                  z(document.body).on("sticky_kit:recalc", t),
                  o.on("sticky_kit:detach", e),
                  setTimeout(n, 0)
                );
            }
          },
          i = 0,
          n = this.length;
        i < n;
        i++
      )
        (e = this[i]), t(z(e));
      return this;
    };
  }.call(this),
  (Shopify.money_format = "{{amount}} €"),
  (Shopify.formatMoney = function (e, t) {
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      t = t || this.money_format;
    function o(e, t) {
      return void 0 === e ? t : e;
    }
    function r(e, t, i, n) {
      if (
        ((t = o(t, 2)), (i = o(i, ".")), (n = o(n, ",")), isNaN(e) || null == e)
      )
        return 0;
      e = (e = (e / 100).toFixed(t)).split(".");
      return (
        e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) +
        (e[1] ? n + e[1] : "")
      );
    }
    switch (t.match(n)[1]) {
      case "amount":
        i = r(e, 2);
        break;
      case "amount_no_decimals":
        i = r(e, 0);
        break;
      case "amount_with_comma_separator":
        i = r(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = r(e, 0, ".", ",");
    }
    return t.replace(n, i);
  }),
  (function (c) {
    var i;
    function d() {
      50 <= c(window).scrollTop()
        ? (c("header,#SBTrustedShopsMobile").addClass("scrolled"),
          c("#fade-it-on-scroll").slideUp(550))
        : (c("header,#SBTrustedShopsMobile").removeClass("scrolled"),
          c("#fade-it-on-scroll").slideDown(550)),
        c(window).width();
    }
    function u(e, t, i) {
      var n = new Date();
      n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3);
      n = "expires=" + n.toUTCString();
      document.cookie = e + "=" + t + ";" + n + ";path=/";
    }
    function p() {
      c('input[type="checkbox"]:not(.hide)').each(function () {
        if (c(this).hasClass("hide")) return !0;
        var e = c('<div class="checkbox"></div>');
        c(this).before(e),
          c(this).is(":checked") && c(e).addClass("active"),
          c(this).addClass("hide");
      }),
        c(".checkbox")
          .off("click")
          .click(function (e) {
            0 === c(this).parent("label").length
              ? (e.stopPropagation(),
                c(this).toggleClass("active"),
                c(this).hasClass("active")
                  ? c(this).next().prop("checked", !0)
                  : c(this).next().prop("checked", !1))
              : c(this).next().trigger("change");
          });
    }
    ((i = jQuery).fn.onSwipe = function (a, l, e, t) {
      var c, d, u, p, f, h;
      return (
        jQuery.isFunction(a)
          ? (null == l && (l = 100),
            null == e && (e = 30),
            null == t && (t = 30),
            (h = 0),
            i(this).on("touchstart", function (e) {
              (c = e.touches[0].clientX),
                (d = e.touches[0].clientY),
                (f = setInterval(function () {
                  h += 10;
                }, 10));
            }),
            i(this).on("touchend", function (e) {
              var t, i, n, o, r, s;
              (u = e.changedTouches[0].clientX),
                (p = e.changedTouches[0].clientY),
                clearInterval(f),
                l <= h &&
                  a(
                    ((t = d),
                    (n = p),
                    (s = { up: !(r = o = 30), right: !1, down: !1, left: !1 }),
                    (i = u) < (e = c) && o <= e - i
                      ? (s.left = !0)
                      : e < i && o <= i - e && (s.right = !0),
                    t < n && r <= n - t
                      ? (s.down = !0)
                      : n < t && r <= t - n && (s.up = !0),
                    s)
                  ),
                (h = 0);
            }))
          : console.error(
              "You need to pass a function in order to process swipe data."
            ),
        i(this)
      );
    }),
      c(window).on("scroll", function () {
        d();
      }),
      c(document).ready(function () {

        function renderCart(e) {
          // Fetch updated content from both endpoints simultaneously
          const cartRequests = [
            jQuery.ajax({ url: "/cart?sections=cart-items" }),
            jQuery.ajax({ url: "/cart?sections=sliding-cart" })
          ];
        
          // Process both responses
          Promise.all(cartRequests)
            .then(([cartItemsResponse, slidingCartResponse]) => {
              try {
                // Parse both responses
                const cartItemsData = cartItemsResponse['cart-items'];
                const slidingCartData = slidingCartResponse['sliding-cart'];
        
                // Extract cart content
                const cartItemsContent = cartItemsData;
                const slidingCartContent = slidingCartData;
        
                // Update cart-items (if content exists)
                if (cartItemsContent) {
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = cartItemsContent;
                  const cartFeedContent = tempDiv.querySelector('#the-cart-feed');
                  if (cartFeedContent) {
                    jQuery("#the-cart-feed").html(cartFeedContent.innerHTML);
                  } else {
                    jQuery("#the-cart-feed").html(cartItemsContent);
                  }
                }
        
                // Update sliding-cart (if content exists)
                if (slidingCartContent) {
                  const tempDiv = document.createElement('div');
                  tempDiv.innerHTML = slidingCartContent;
                  const slidingCartFeedContent = tempDiv.querySelector('#cart-items');
                  if (slidingCartFeedContent) {
                    jQuery("#cart-items").html(slidingCartFeedContent.innerHTML);
                  } else {
                    jQuery("#cart-items").html(slidingCartContent);
                  }
                }
        
                // Reinitialize changeCartItem after updating the DOM
                changeCartItem(e);
        
              } catch (error) {
                console.error("Failed to parse response data:", error);
              }
            })
            .catch(error => {
              console.error("Failed to fetch cart data:", error);
            });
        }
        
        function changeCartItem(e) {
          c(".one-cart-item input").on("change", function () {
            c(".one-cart-item").css("opacity", "0.5");
            var i = {},
              e = c(this).closest(".one-cart-item").parent();
            c(e)
              .find(".one-cart-item")
              .each(function () {
                var e = c(this).attr("data-id"),
                  t = c(this).find("input").val();
                void 0 !== e && (i[e] = t);
              }),
              jQuery.post(
                "/cart/change.js",
                { line: c(this).closest(".one-cart-item").attr("data-index"), quantity: c(this).val() },
                function (e) {
                  var t, o, i, d;
                  c(".one-cart-item").css("opacity", "1"),
                    (t = e),
                    (o = t.item_count), // Get total items in cart
                    (i = Shopify.formatMoney(t.items_subtotal_price)),
                    (e = Shopify.formatMoney(t.total_price)),
                    (d = Shopify.formatMoney(t.total_discount)),
                    c(".total_price").html(e),
                    c(".items_subtotal_price").html(i),
                    c(".items_total_discount").html(d),
                    t.total_discount === 0 && c(".rabatt, .discount-codes").remove(),            

                    renderCart(e);

                    c("#open-sliding-cart span").html(o), // Set value to total items in cart
                    r();
                },
                "json"
              );
          });

          c(".oci-plus").click(function (e) {
            e.preventDefault();
            e = parseInt(c(this).parent().find("input").val());
            e++,
              c(this).parent().find("input").val(e),
              c(this).parent().find("input").trigger("change");
          }),
          c(".oci-minus").click(function (e) {
            e.preventDefault();
            var $input = c(this).parent().find("input");
            var quantity = parseInt($input.val());
            var $oneCartItem = c(this).closest(".one-cart-item");
            
            if (quantity <= 1) {
                // Используем тот же код, что и для иконки удаления
                $input.val(0);
                $input.trigger("change");
                var itemId = $oneCartItem.attr("data-id");
                c('.one-cart-item[data-id="' + itemId + '"]').remove();
                c('.one-cart-item-wrapper[data-id="' + itemId + '"]').remove();
            } else {
                // Уменьшаем количество на единицу
                quantity--;
                $input.val(quantity);
                $input.trigger("change");
            }
          });
        }
        0 < c("#single-article-content").length &&
          (c("#toc-blog").html("<p>Inhaltsverzeichnis</p><ol></ol>"),
          c("#single-article-content")
            .find("h2,h3")
            .each(function (e, t) {
              var i = c(
                '<a class="the-anchor" id="section-' + (e + 1) + '"></a>'
              );
              c(t).before(i),
                "" !== c(t).text().trim() &&
                  c("#toc-blog ol").append(
                    c(
                      '<li><a href="#section-' +
                        (e + 1) +
                        '">' +
                        c(t).text() +
                        "</a></li>"
                    )
                  );
            }),
          4 < c("#toc-blog ol li").length &&
            (c("#toc-blog").append(
              c(
                '<p class="text-center" id="read-more-toc-p"><a href="#" id="read-more-toc">Mehr anzeigen</a></p>'
              )
            ),
            c("#toc-blog ol li").addClass("hidden-toc"),
            c("#toc-blog ol li").slice(0, 4).removeClass("hidden-toc"),
            c("#read-more-toc").click(function (e) {
              e.preventDefault(),
                c(".hidden-toc").removeClass("hidden-toc"),
                c(this).parent().remove();
            })),
          c("#toc-blog ol li").length < 3 && c("#toc-blog").remove()),
          c(".additional-team-members").each(function () {
            var e = c(this).find(".col-sm-3");
            c("#about-page-team .row-spaced").append(e),
              c(this).closest(".shopify-section").remove();
          }),
          4 < c("#about-page-team .col-sm-3").length &&
            c("#about-page-team .row-center").removeClass("row-center"),
          c(".product-testimonials-2")
            .parent()
            .next()
            .find("#details")
            .addClass("after-testimonials"),
           c('.one-testimonial-nav').click(function(e){
      e.preventDefault();
      var key = c(this).attr('data-key');
      c('.one-testimonial-nav,.one-testimonial').removeClass('active');
      c('.one-testimonial-nav[data-key="'+key+'"],.one-testimonial[data-key="'+key+'"]').addClass('active');
    }),
          c('.trast-slider-slick').slick({
            arrows: true,
            dots: !1,
            slidesToShow:4,
            responsive:[
            {
              breakpoint: 991,
              settings:{
                slidesToShow: 2,
                arrows: true,
                dots: !1
              }
            }
          ]
          }),
          setTimeout(function () {
            c(".home-newsletter .the-home-newsleeter").addClass("load-picture");
          }, 2e3),
          c("header a").mouseenter(function () {}),
          c(".open-app").click(function (e) {
            e.preventDefault(), c(".si-reset").trigger("click");
          }),
          d(),
          p(),
          setTimeout(function () {
            p();
          }, 3e3),
          setTimeout(function () {
            p();
          }, 1e3),
          c('input[type="checkbox"]').on("change", function () {
            c(this).is(":checked")
              ? c(this).prev().addClass("active")
              : c(this).prev().removeClass("active");
          }),
          c(".template-page-about .home-page-hero-floating a").click(function (
            e
          ) {
            e.preventDefault();
            e = 60;
            1024 < c(window).width() && (e = 100),
              c("body,html").animate(
                { scrollTop: c("#about-page-nav-above").offset().top - e },
                1e3
              );
          }),
          c(".so-accordion-wrapper").each(function (e, t) {
            var r = c('<div class="product-faq"></div>');
            c(this)
              .find(".so-tab")
              .each(function (e, t) {
                var i = c(this).clone();
                c(i).find(".so-tab-content").remove();
                var i = c(i)[0].innerText.trim(),
                  n = c(this).find(".so-tab-content").html(),
                  o = c(".faq-source").html(),
                  n = c(
                    '<div class="one-product-faq"><div class="one-product-question">' +
                      i +
                      o +
                      '</div><div class="one-product-answer">' +
                      n +
                      "</div></div>"
                  );
                c(r).append(n);
              }),
              c(t).after(r),
              c(t).remove();
          });
        var e, t, i, n;
        window.location.hash;
        function r() {
          0 === c(".one-cart-item").length
            ? c("body").addClass("empty-cart")
            : c("body").removeClass("empty-cart");
        }
        function s(e) {
          c(e).css("min-height", "0px"), c(e).css("box-sizing", "border-box");
          var i = 0;
          c("#mobile-categories select").on("change", function () {
            window.location = c(this).val();
          }),
            c(e).each(function (e, t) {
              t = c(t).outerHeight();
              i < t && (i = t);
            }),
            c(e).css("min-height", i);
        }
        function o() {
          var e,
            t,
            i,
            n = c(".one-product-slide"),
            o = 4;
          for (
            c(window).width() <= 1024 && (o = 2),
              c(window).width() <= 768 && (o = 2),
              e = 0,
              t = n.length;
            e < t;
            e += o
          )
            (i = n.slice(e, e + o)), s(c(i).find(".op-description"));
          setTimeout(function () {
            s(".the-products-slider .op-description");
          }, 200);
        }
        c("#arrow-down-mobile").click(function (e) {
          e.preventDefault();
          e = c(this).closest(".shopify-section").next().offset().top - 50;
          c("body,html").animate({ scrollTop: e }, 1e3);
        }),
          c(".oci-remove-and-price a").click(function (e) {
            e.preventDefault(),
              c(this).closest(".one-cart-item").find("input").val(0),
              c(this).closest(".one-cart-item").find("input").trigger("change");
            e = c(this).closest(".one-cart-item").attr("data-id");
            c('.one-cart-item[data-id="' + e + '"]').remove();
            c('.one-cart-item-wrapper[data-id="' + e + '"]').remove();
          }),
          c(".product-form").submit(function (e) {
            e.preventDefault();
            c(".top-right-product .product-form").css("opacity", 0.5);
            
            const formData = c(this).serializeArray();
            const variantId = formData.find(field => field.name === "id").value;
            const quantity = formData.find(field => field.name === "quantity")?.value || 1;
            const upsellProducts = formData.find(field => field.name === "upsell_products")?.value;
            const autoAddUpsell = formData.find(field => field.name === "auto_add_upsell")?.value === "true";

            let items = [{
              id: variantId,
              quantity: parseInt(quantity)
            }];

            if (autoAddUpsell && upsellProducts) {
              const upsellIds = upsellProducts.split(',');
              upsellIds.forEach(id => {
                items.push({
                  id: parseInt(id),
                  quantity: 1
                });
              });
            }

            jQuery.post(
              "/cart/add.js",
              { items },
              function(e) {
                u("show_cart", "true", 1);
                window.location.reload(true);
              },
              "json"
            );
          }),
          r(),
          c(".one-cart-item input").on("change", function () {
            c(".one-cart-item").css("opacity", "0.5");
            var i = {},
              e = c(this).closest(".one-cart-item").parent();
            c(e)
              .find(".one-cart-item")
              .each(function () {
                var e = c(this).attr("data-id"),
                  t = c(this).find("input").val();
                void 0 !== e && (i[e] = t);
              }),
              jQuery.post(
                "/cart/change.js",
                { line: c(this).closest(".one-cart-item").attr("data-index"), quantity: c(this).val() },
                function (e) {
                  var t, o, i, d;
                  c(".one-cart-item").css("opacity", "1"),
                    (t = e),
                    (o = 0),
                    (i = Shopify.formatMoney(t.items_subtotal_price)),
                    (e = Shopify.formatMoney(t.total_price)),
                    (d = Shopify.formatMoney(t.total_discount)),
                    c(".total_price").html(e),
                    c(".items_subtotal_price").html(i),
                    c(".items_total_discount").html(d),
                    t.total_discount === 0 && c(".rabatt, .discount-codes").remove(),

                    renderCart(e);

                    c("#header-icons a span").html(o),
                    r();
                },
                "json"
              );
          }),
          c(window).width() < 575 &&
            (c(".product-section-1,.product-section-2").each(function (e, t) {
              750 < c(t).height() &&
                (c(this).addClass("show-more"),
                c(this).append(
                  c(
                    '<div class="show-more-floating"><a href="#"><span>+</span><span>Mehr anzeigen</span></a></div>'
                  )
                ));
            }),
            c(".show-more-floating a").click(function (e) {
              e.preventDefault(),
                c(this).closest(".show-more").removeClass("show-more"),
                c(this).parent().remove();
            })),
          c("#mobile-menu ul li.has-submenu > a").click(function (e) {
            e.preventDefault();
          }),
          c("#back-to-top").click(function (e) {
            e.preventDefault(), c("body,html").animate({ scrollTop: 0 }, 1e3);
          }),
          c("#scollable li:not(.has-submenu) > a").click(function () {}),
          c(document).on('click', '.mobile-submenu-controlls-mainink a, .mobile-secondary-menu a', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var url = c(this).attr('href');
            if (url) {
              window.location.href = url;
            }
          }),
          c("#mobile-menu .mobile-main-menu ul li.has-submenu").click(function (e) {
            e.preventDefault(),
              c(this).toggleClass("active"),
              c(this).find("ul").fadeToggle(250);
          }),
          c("#mobile-menu ul li.has-submenu li a").click(function (e) {
            e.stopPropagation();
          }),
          c('.customer.login a[href="#recover"]').click(function (e) {
            e.preventDefault(),
              c("#login-wrapper").css("display", "none"),
              c("#recover-wrapper").css("display", "block");
          }),
          c('.customer.login a[href="#login"]').click(function (e) {
            e.preventDefault(),
              c("#login-wrapper").css("display", "block"),
              c("#recover-wrapper").css("display", "none");
          }),
          0 < c(".customer.login").length &&
            ((e = c("h1#recover")),
            (t = c("h1#recover + div")),
            (i = c("h1#login")),
            (n = c("h1#login + div")),
            c(".customer.login").append(
              c(
                '<div class="row row-spaced"><div id="login-wrapper" class="col-sm-12"></div><div id="recover-wrapper"  class="col-sm-12"></div></div>'
              )
            ),
            c("#login-wrapper").append(i),
            c("#login-wrapper").append(n),
            c("#recover-wrapper").append(e),
            c("#recover-wrapper").append(t)),
          c(".customer").css("display", "block"),
          c(".mobile-trigger-wrapper").click(function (e) {
            e.preventDefault();
            e = c(this).closest("#sort-wrapper,.sort-wrapper");
            c("#sort-wrapper,.sort-wrapper").not(e).removeClass("active"),
              c(e).toggleClass("active");
            e = c(e).find(".dropdown-expanded");
            c(".dropdown-expanded").not(e).slideUp(550), c(e).slideToggle(550);
          }),
          c(".dropdown-expanded a").click(function (e) {
            e.preventDefault();
            e = c(this).attr("href");
            c(this)
              .closest("#sort-wrapper,.sort-wrapper")
              .find("select")
              .val(e)
              .trigger("change"),
              c(this).closest(".dropdown-expanded").slideUp(550),
              c("#sort-wrapper,.sort-wrapper").removeClass("active");
          }),
          0 === c(".one-art-cat.active").length &&
            c(".one-art-cat:first-child").addClass("active"),
          c(".one-variation-selection").click(function (e) {
            e.preventDefault();
            e = c(this).attr("data-value");
            c(".one-variation-selection").removeClass("active"),
              c(this).addClass("active"),
              c('select[name="id"]').val(e);
            e = c(this).find("div:last-child").find("p:last-child").html();
            c(".current-price b").html(e);
          }),
          c(".op-picture").each(function (e, t) {
            0 < c(this).find(".discount-badge").length &&
              0 < c(this).find(".one-tag").length &&
              c(this).addClass("has-both-badges");
          }),
          c(window).width() < 5 &&
            (c(".payment-and-quantity .oci-quantity").html(
              '<select name="quantity"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option><option value="5">5</option></select>'
            ),
            c(".oci-quantity select").wrap(
              c('<span class="select-wrapper"></span>')
            )),
          c(".home-inspirations .one-inspiration").click(function () {
            window.location = c(this).find("a").attr("href");
          }),
          c(".home-newsletter").parent().addClass("overflow-visible"),
          c("#shopify-section-header").addClass("overflow-visible"),
          c("#search-icon").click(function (e) {
            e.preventDefault(),
              c("header").hasClass("show-search") ||
                c("header").addClass("show-search");
          }),
          c("#close-search").click(function (e) {
            e.preventDefault(), c("header").removeClass("show-search");
          }),
          c(".product-nav a").each(function () {
            var e = c(this).attr("href");
            0 === c(e).length && c(this).remove();
          }),
          c("#sort-form select").on("change", function () {
            var e = c(this).val(),
              t = c("#collection-products > div"),
              i = t.children("div");
            "default" === e
              ? i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("key"))),
                    (t = parseInt(c(t).data("key")));
                  return t < e ? 1 : -1;
                })
              : "price-asc" === e
              ? i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("price"))),
                    (t = parseInt(c(t).data("price")));
                  return t < e ? 1 : -1;
                })
              : i.detach().sort(function (e, t) {
                  (e = parseInt(c(e).data("price"))),
                    (t = parseInt(c(t).data("price")));
                  return t < e ? -1 : 1;
                }),
              t.append(i),
              o();
          }),
          o(),
          c(".oci-plus").click(function (e) {
            e.preventDefault();
            e = parseInt(c(this).parent().find("input").val());
            e++,
              c(this).parent().find("input").val(e),
              c(this).parent().find("input").trigger("change");
          }),
          c(".oci-minus").click(function (e) {
            e.preventDefault();
            var $input = c(this).parent().find("input");
            var quantity = parseInt($input.val());
            var $oneCartItem = c(this).closest(".one-cart-item");
            
            if (quantity <= 1) {
                // Используем тот же код, что и для иконки удаления
                $input.val(0);
                $input.trigger("change");
                var itemId = $oneCartItem.attr("data-id");
                c('.one-cart-item[data-id="' + itemId + '"]').remove();
                c('.one-cart-item-wrapper[data-id="' + itemId + '"]').remove();
            } else {
                // Уменьшаем количество на единицу
                quantity--;
                $input.val(quantity);
                $input.trigger("change");
            }
        });
        var a = [];
        function l(e) {
          c(e).slick({
            slidesToShow: 4,
            responsive: [
              { breakpoint: 1025, settings: { slidesToShow: 2 } },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  centerPadding: "20px",
                  centerMode: true,
                  dots: !0,
                },
              },
            ],
          });
        }
        0 < c(".products-slider-section").length &&
          (c(".the-products-slider").each(function (e, t) {
            a.push(c(t).clone());
          }),
          c(".products-slider-section").each(function (e, t) {
            c(this).attr("data-key", e);
          }),
          c(".the-products-slider").each(function () {
            c(this).find(".one-product-slide").slice(8).remove();
          })),
          "true" ===
            (function (e) {
              for (
                var t = e + "=", i = document.cookie.split(";"), n = 0;
                n < i.length;
                n++
              ) {
                for (var o = i[n]; " " == o.charAt(0); ) o = o.substring(1);
                if (0 == o.indexOf(t)) return o.substring(t.length, o.length);
              }
              return "";
            })("show_cart") &&
            (c("#sliding-cart").addClass("active"),
            c("body").addClass("menu-opened"),
            u("show_cart", "false", "1")),
          c("#open-sliding-cart").click(function (e) {
            e.preventDefault(),
              c("#sliding-cart").addClass("active"),
              c("body").addClass("menu-opened");
          }),
          c("#sliding-cart").click(function () {
            c("#sliding-cart").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c("#sliding-cart form").click(function (e) {
            e.stopPropagation();
          }),
          c("#close-sc").click(function (e) {
            // e.preventDefault(),
              c("#sliding-cart").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c("#close-menu, .mobile-menu__overlay").click(function (e) {
            e.preventDefault(),
              c("#mobile-menu").removeClass("active"),
              c("body").removeClass("menu-opened");
          }),
          c("#menu-open").click(function (e) {
            e.preventDefault(),
              c("#mobile-menu").addClass("active"),
              c("body").addClass("menu-opened");
          }),
          c(".products-slider-top a").click(function (e) {
            e.preventDefault();
            var t = c(this).attr("data-key"),
              i = c(this).closest(".products-slider-section");
            c(i).find(".products-slider-top a").removeClass("active"),
              c(i)
                .find('.products-slider-top a[data-key="' + t + '"]')
                .addClass("active");
            (e = c(this).closest(".products-slider-section").attr("data-key")),
              (e = c(a[parseInt(e)]).clone());
            c(i).find(".the-products-slider").after(e),
              c(i).find(".the-products-slider").first().remove(),
              "all" !== t &&
                c(e)
                  .find(".one-product-slide")
                  .not(".collection-" + t)
                  .remove(),
              c(e).find(".one-product-slide").slice(8).remove(),
              l(e);
          }),
          0 === c("#team").length && c("#about-nav-1").remove(),
          0 === c("#production").length && c("#about-nav-2").remove(),
          0 === c("#quality").length && c("#about-nav-3").remove(),
          0 === c("#ap-last").length && c("#about-nav-4").remove(),
          1024 < c(window).width()
            ? (c("#about-page-nav").sticky({ topSpacing: 0 }),
              c("#categories:not(.articles-categories)").stick_in_parent({
                offset_top: 150,
              }))
            : c("#about-page-nav").sticky({ topSpacing: 0 }),
          c("#about-page-nav").on("sticky-start", function () {
            c("header").fadeOut(550);
          }),
          c("#about-page-nav").on("sticky-end", function () {
            c("header").fadeIn(550);
          }),
          c(".ppw-links a").click(function (e) {
            e.preventDefault();
            var t = c(this).attr("href"),
              e = 20;
            1024 < c(window).width() && (e = 0),
              c(t) &&
                c("body,html").animate({ scrollTop: c(t).offset().top - e });
          }),
          c("#about-page-nav a,.product-nav a").click(function (e) {
            e.preventDefault();
            var t = c(this).attr("href"),
              e = 60;
            1024 < c(window).width() && (e = 150),
              c(t) &&
                c("body,html").animate({ scrollTop: c(t).offset().top - e });
          }),
          l(".the-products-slider"),
          c(".one-product-question").click(function (e) {
            e.preventDefault();
            var t = c(this).parent(),
              e = c(this)
                .closest(".product-faq")
                .find(".one-product-faq")
                .not(t);
            c(t).addClass("active"),
              c(e).removeClass("active"),
              c(t).find(".one-product-answer").slideDown(550),
              c(e).find(".one-product-answer").slideUp(550);
          }),
          0 < c(".one-product-question").length &&
            c(".one-product-faq")
              .find(".one-product-question")
              .first()
              .trigger("dontclick"),
          c(".home-testimonials-slider").slick({
            slidesToShow: 2,
            responsive: [
              {
                breakpoint: 575,
                settings: { slidesToShow: 1, dots: !0, arrows: !1 },
              },
            ],
          }),
          c(".inspirations-slider").slick({
            variableWidth: false,
            dots: true,
            arrows: true,
            slidesToShow: 3,
            centerMode: false,
            responsive: [
              {
                breakpoint: 1025,
                settings:{
                  slidesToShow:2
                }
              },
              { 
                breakpoint: 575, 
                settings: 
                { dots: !0, slidesToShow: 1 } 
              },
            ],
          }),
          c(".p-test-2-slider").slick({
            slidesToShow: 3,
            responsive: [
              {
                breakpoint: 991,
                settings: { slidesToShow: 2, arrows: !1, dots: !0 },
              },
              {
                breakpoint: 575,
                settings: { slidesToShow: 1, arrows: !1, dots: !0 },
              },
            ],
          }),
          c(".home-quotes .row,.home-features .row").slick({
            responsive: [
              { 
                breakpoint: 1e5, settings: "unslick" },
              {
                breakpoint: 0,
                settings: { adaptiveHeight: !0, arrows: !0, dots: !0 },
              },
            ],
          });
      });

    

  })(jQuery),

jQuery(function ($) {
  let active     = null;
  let startX     = 0;
  let scrollOrig = 0;
  let dragged    = false;


  $(document).ready(function(){
    function dedupeSubtabs() {
      $('.jdgm-rev-widg__actions').each(function () {
        var seen = {};
        $(this).find('.jdgm-subtab').each(function () {
          var $el = $(this);
          var key = ($el.attr('href') || $el.data('target') || $el.text() || '')
            .toString().trim().toLowerCase();
          if (seen[key]) {
            $el.remove();
          } else {
            seen[key] = true;
          }
        });
      });
    }

    dedupeSubtabs();

    var mo = new MutationObserver(function (mut) {
      for (var i = 0; i < mut.length; i++) {
        if (mut[i].addedNodes && mut[i].addedNodes.length) {
          dedupeSubtabs();
          break;
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  });

  $(document).on('mousedown touchstart', '.subcategories-gwa', function (e) {
    e.preventDefault();
    active     = this;
    dragged    = false;
    startX     = (e.pageX || e.originalEvent.touches[0].pageX);
    scrollOrig = active.scrollLeft;

    $(active).addClass('is-grabbing');
  });

  $(document).on('mousemove touchmove', function (e) {
    if (!active) return;

    const x    = (e.pageX || e.originalEvent.touches[0].pageX);
    const dist = x - startX;

    if (Math.abs(dist) > 5) dragged = true;
    active.scrollLeft = scrollOrig - dist;

    if (e.type.startsWith('touch')) e.preventDefault();
  });

  $(document).on('mouseup touchend touchcancel', function () {
    if (!active) return;
    $(active).removeClass('is-grabbing');
    active = null;
  });

  $(document).on('click', '.subcategories-gwa a, .subcategories-gwa .subcategories-gwa-card', function (e) {
    if (dragged) e.preventDefault();
  });

  $(document).on('wheel', '.subcategories-gwa', function (e) {
    if (Math.abs(e.originalEvent.deltaY) > Math.abs(e.originalEvent.deltaX)) {
      this.scrollLeft += e.originalEvent.deltaY;
      e.preventDefault();
    }
  });
}),
jQuery(function ($) {
  $('.subcategories-gmain').each(function () {
    const $wrap   = $(this);
    const $tracks = $wrap.find('.subcategories-gwa');

    function update() {
      let hasOverflow = false;
      let atEndAll    = true;

      $tracks.each(function () {
        const el = this;

        const rowHasOverflow = el.scrollWidth > el.clientWidth + 1;
        if (rowHasOverflow) {
          hasOverflow = true;
          const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
          if (!atEnd) atEndAll = false;
        }
      });

      $wrap.toggleClass('has-overflow', hasOverflow);
      $wrap.toggleClass('scrolled-end', atEndAll);
    }

    update();

    $(window).on('resize load', update);
    $tracks.on('scroll', update);
  });

}),
  (function (e) {
    var t = (function (n, p, r) {
      "use strict";
      var f, h;
      if (
        ((function () {
          var e,
            t = {
              lazyClass: "lazyload",
              loadedClass: "lazyloaded",
              loadingClass: "lazyloading",
              preloadClass: "lazypreload",
              errorClass: "lazyerror",
              autosizesClass: "lazyautosizes",
              fastLoadedClass: "ls-is-cached",
              iframeLoadMode: 0,
              srcAttr: "data-src",
              srcsetAttr: "data-srcset",
              sizesAttr: "data-sizes",
              minSize: 40,
              customMedia: {},
              init: !0,
              expFactor: 1.5,
              hFac: 0.8,
              loadMode: 2,
              loadHidden: !0,
              ricTimeout: 0,
              throttleDelay: 125,
            };
          for (e in ((h = n.lazySizesConfig || n.lazysizesConfig || {}), t))
            e in h || (h[e] = t[e]);
        })(),
        !p || !p.getElementsByClassName)
      )
        return { init: function () {}, cfg: h, noSupport: !0 };
      function d(e, t) {
        le(e, t) ||
          e.setAttribute("class", (e[Z]("class") || "").trim() + " " + t);
      }
      function u(e, t) {
        (t = le(e, t)) &&
          e.setAttribute("class", (e[Z]("class") || "").replace(t, " "));
      }
      function g(e, t) {
        var i;
        !J && (i = n.picturefill || h.pf)
          ? (t && t.src && !e[Z]("srcset") && e.setAttribute("srcset", t.src),
            i({ reevaluate: !0, elements: [e] }))
          : t && t.src && (e.src = t.src);
      }
      function e(i, e) {
        return e
          ? function () {
              fe(i);
            }
          : function () {
              var e = this,
                t = arguments;
              fe(function () {
                i.apply(e, t);
              });
            };
      }
      function t(e) {
        function t() {
          var e = r.now() - n;
          e < 99 ? te(t, 99 - e) : (ne || o)(o);
        }
        var i,
          n,
          o = function () {
            (i = null), e();
          };
        return function () {
          (n = r.now()), (i = i || te(t, 99));
        };
      }
      function i() {
        !i.i && p.getElementsByClassName && ((i.i = !0), ge._(), he._());
      }
      var o,
        s,
        a,
        v,
        m,
        y,
        w,
        l,
        b,
        k,
        x,
        T,
        C,
        S,
        A,
        c,
        E,
        $,
        z,
        D,
        L,
        N,
        j,
        H,
        O,
        P,
        M,
        q,
        W,
        I,
        _,
        F,
        R,
        B,
        U,
        X,
        Y,
        Q,
        V,
        G = p.documentElement,
        J = n.HTMLPictureElement,
        K = "addEventListener",
        Z = "getAttribute",
        ee = n[K].bind(n),
        te = n.setTimeout,
        ie = n.requestAnimationFrame || te,
        ne = n.requestIdleCallback,
        oe = /^picture$/i,
        re = ["load", "error", "lazyincluded", "_lazyloaded"],
        se = {},
        ae = Array.prototype.forEach,
        le = function (e, t) {
          return (
            se[t] || (se[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")),
            se[t].test(e[Z]("class") || "") && se[t]
          );
        },
        ce = function (t, i, e) {
          var n = e ? K : "removeEventListener";
          e && ce(t, i),
            re.forEach(function (e) {
              t[n](e, i);
            });
        },
        de = function (e, t, i, n, o) {
          var r = p.createEvent("Event");
          return (
            ((i = i || {}).instance = f),
            r.initEvent(t, !n, !o),
            (r.detail = i),
            e.dispatchEvent(r),
            r
          );
        },
        ue = function (e, t) {
          return (getComputedStyle(e, null) || {})[t];
        },
        pe = function (e, t, i) {
          for (
            i = i || e.offsetWidth;
            i < h.minSize && t && !e._lazysizesWidth;

          )
            (i = t.offsetWidth), (t = t.parentNode);
          return i;
        },
        fe = ((Q = []), (V = Y = []), (Se._lsFlush = Ce), Se),
        he =
          ((N = /^img$/i),
          (j = /^iframe$/i),
          (H = "onscroll" in n && !/(gle|ing)bot/.test(navigator.userAgent)),
          (M = -1),
          (q = function (e) {
            return (
              (A = null == A ? "hidden" == ue(p.body, "visibility") : A) ||
              !(
                "hidden" == ue(e.parentNode, "visibility") &&
                "hidden" == ue(e, "visibility")
              )
            );
          }),
          (c = ye),
          ($ = P = O = 0),
          (z = h.throttleDelay),
          (D = h.ricTimeout),
          (L =
            ne && 49 < D
              ? function () {
                  ne(we, { timeout: D }),
                    D !== h.ricTimeout && (D = h.ricTimeout);
                }
              : e(function () {
                  te(we);
                }, !0)),
          (I = e(be)),
          (_ = function (e) {
            I({ target: e.target });
          }),
          (F = e(function (t, e, i, n, o) {
            var r, s, a, l, c;
            (a = de(t, "lazybeforeunveil", e)).defaultPrevented ||
              (n && (i ? d(t, h.autosizesClass) : t.setAttribute("sizes", n)),
              (r = t[Z](h.srcsetAttr)),
              (i = t[Z](h.srcAttr)),
              o && (s = (c = t.parentNode) && oe.test(c.nodeName || "")),
              (l = e.firesLoad || ("src" in t && (r || i || s))),
              (a = { target: t }),
              d(t, h.loadingClass),
              l && (clearTimeout(y), (y = te(me, 2500)), ce(t, _, !0)),
              s && ae.call(c.getElementsByTagName("source"), ke),
              r
                ? t.setAttribute("srcset", r)
                : i &&
                  !s &&
                  (j.test(t.nodeName)
                    ? ((n = i),
                      0 ==
                      (c =
                        (e = t).getAttribute("data-load-mode") ||
                        h.iframeLoadMode)
                        ? e.contentWindow.location.replace(n)
                        : 1 == c && (e.src = n))
                    : (t.src = i)),
              o && (r || s) && g(t, { src: i })),
              t._lazyRace && delete t._lazyRace,
              u(t, h.lazyClass),
              fe(function () {
                var e = t.complete && 1 < t.naturalWidth;
                (l && !e) ||
                  (e && d(t, h.fastLoadedClass),
                  be(a),
                  (t._lazyCache = !0),
                  te(function () {
                    "_lazyCache" in t && delete t._lazyCache;
                  }, 9)),
                  "lazy" == t.loading && P--;
              }, !0);
          })),
          (B = t(function () {
            (h.loadMode = 3), W();
          })),
          {
            _: function () {
              (l = r.now()),
                (f.elements = p.getElementsByClassName(h.lazyClass)),
                (v = p.getElementsByClassName(
                  h.lazyClass + " " + h.preloadClass
                )),
                ee("scroll", W, !0),
                ee("resize", W, !0),
                ee("pageshow", function (e) {
                  var t;
                  !e.persisted ||
                    ((t = p.querySelectorAll("." + h.loadingClass)).length &&
                      t.forEach &&
                      ie(function () {
                        t.forEach(function (e) {
                          e.complete && R(e);
                        });
                      }));
                }),
                n.MutationObserver
                  ? new MutationObserver(W).observe(G, {
                      childList: !0,
                      subtree: !0,
                      attributes: !0,
                    })
                  : (G[K]("DOMNodeInserted", W, !0),
                    G[K]("DOMAttrModified", W, !0),
                    setInterval(W, 999)),
                ee("hashchange", W, !0),
                [
                  "focus",
                  "mouseover",
                  "click",
                  "load",
                  "transitionend",
                  "animationend",
                ].forEach(function (e) {
                  p[K](e, W, !0);
                }),
                /d$|^c/.test(p.readyState)
                  ? Te()
                  : (ee("load", Te), p[K]("DOMContentLoaded", W), te(Te, 2e4)),
                f.elements.length ? (ye(), fe._lsFlush()) : W();
            },
            checkElems: (W = function (e) {
              var t;
              (e = !0 === e) && (D = 33),
                E ||
                  ((E = !0),
                  (t = z - (r.now() - $)) < 0 && (t = 0),
                  e || t < 9 ? L() : te(L, t));
            }),
            unveil: (R = function (e) {
              var t, i, n, o;
              e._lazyRace ||
                (((!(o =
                  "auto" ==
                  (n =
                    (i = N.test(e.nodeName)) &&
                    (e[Z](h.sizesAttr) || e[Z]("sizes")))) &&
                  m) ||
                  !i ||
                  (!e[Z]("src") && !e.srcset) ||
                  e.complete ||
                  le(e, h.errorClass) ||
                  !le(e, h.lazyClass)) &&
                  ((t = de(e, "lazyunveilread").detail),
                  o && ge.updateElem(e, !0, e.offsetWidth),
                  (e._lazyRace = !0),
                  P++,
                  F(e, t, o, n, i)));
            }),
            _aLSL: xe,
          }),
        ge =
          ((s = e(function (e, t, i, n) {
            var o, r, s;
            if (
              ((e._lazysizesWidth = n),
              e.setAttribute("sizes", (n += "px")),
              oe.test(t.nodeName || ""))
            )
              for (
                r = 0, s = (o = t.getElementsByTagName("source")).length;
                r < s;
                r++
              )
                o[r].setAttribute("sizes", n);
            i.detail.dataAttr || g(e, i.detail);
          })),
          {
            _: function () {
              (o = p.getElementsByClassName(h.autosizesClass)), ee("resize", a);
            },
            checkElems: (a = t(function () {
              var e,
                t = o.length;
              if (t) for (e = 0; e < t; e++) ve(o[e]);
            })),
            updateElem: ve,
          });
      function ve(e, t, i) {
        var n = e.parentNode;
        n &&
          ((i = pe(e, n, i)),
          (t = de(e, "lazybeforesizes", { width: i, dataAttr: !!t }))
            .defaultPrevented ||
            ((i = t.detail.width) && i !== e._lazysizesWidth && s(e, n, t, i)));
      }
      function me(e) {
        P--, (e && !(P < 0) && e.target) || (P = 0);
      }
      function ye() {
        var e,
          t,
          i,
          n,
          o,
          r,
          s,
          a,
          l,
          c,
          d,
          u = f.elements;
        if ((w = h.loadMode) && P < 8 && (e = u.length)) {
          for (t = 0, M++; t < e; t++)
            if (u[t] && !u[t]._lazyRace)
              if (!H || (f.prematureUnveil && f.prematureUnveil(u[t]))) R(u[t]);
              else if (
                (((s = u[t][Z]("data-expand")) && (o = +s)) || (o = O),
                l ||
                  ((l =
                    !h.expand || h.expand < 1
                      ? 500 < G.clientHeight && 500 < G.clientWidth
                        ? 500
                        : 370
                      : h.expand),
                  (c = (f._defEx = l) * h.expFactor),
                  (d = h.hFac),
                  (A = null),
                  O < c && P < 1 && 2 < M && 2 < w && !p.hidden
                    ? ((O = c), (M = 0))
                    : (O = 1 < w && 1 < M && P < 6 ? l : 0)),
                a !== o &&
                  ((b = innerWidth + o * d),
                  (k = innerHeight + o),
                  (r = -1 * o),
                  (a = o)),
                (c = u[t].getBoundingClientRect()),
                (S = c.bottom) >= r &&
                  (x = c.top) <= k &&
                  (C = c.right) >= r * d &&
                  (T = c.left) <= b &&
                  (S || C || T || x) &&
                  (h.loadHidden || q(u[t])) &&
                  ((m && P < 3 && !s && (w < 3 || M < 4)) ||
                    (function (e, t) {
                      var i,
                        n = e,
                        o = q(e);
                      for (
                        x -= t, S += t, T -= t, C += t;
                        o && (n = n.offsetParent) && n != p.body && n != G;

                      )
                        (o = 0 < (ue(n, "opacity") || 1)) &&
                          "visible" != ue(n, "overflow") &&
                          ((i = n.getBoundingClientRect()),
                          (o =
                            C > i.left &&
                            T < i.right &&
                            S > i.top - 1 &&
                            x < i.bottom + 1));
                      return o;
                    })(u[t], o)))
              ) {
                if ((R(u[t]), (n = !0), 9 < P)) break;
              } else
                !n &&
                  m &&
                  !i &&
                  P < 4 &&
                  M < 4 &&
                  2 < w &&
                  (v[0] || h.preloadAfterLoad) &&
                  (v[0] ||
                    (!s &&
                      (S || C || T || x || "auto" != u[t][Z](h.sizesAttr)))) &&
                  (i = v[0] || u[t]);
          i && !n && R(i);
        }
      }
      function we() {
        (E = !1), ($ = r.now()), c();
      }
      function be(e) {
        var t = e.target;
        t._lazyCache
          ? delete t._lazyCache
          : (me(e),
            d(t, h.loadedClass),
            u(t, h.loadingClass),
            ce(t, _),
            de(t, "lazyloaded"));
      }
      function ke(e) {
        var t,
          i = e[Z](h.srcsetAttr);
        (t = h.customMedia[e[Z]("data-media") || e[Z]("media")]) &&
          e.setAttribute("media", t),
          i && e.setAttribute("srcset", i);
      }
      function xe() {
        3 == h.loadMode && (h.loadMode = 2), B();
      }
      function Te() {
        m ||
          (r.now() - l < 999
            ? te(Te, 999)
            : ((m = !0), (h.loadMode = 3), W(), ee("scroll", xe, !0)));
      }
      function Ce() {
        var e = V;
        for (V = Y.length ? Q : Y, X = !(U = !0); e.length; ) e.shift()();
        U = !1;
      }
      function Se(e, t) {
        U && !t
          ? e.apply(this, arguments)
          : (V.push(e), X || ((X = !0), (p.hidden ? te : ie)(Ce)));
      }
      return (
        te(function () {
          h.init && i();
        }),
        (f = {
          cfg: h,
          autoSizer: ge,
          loader: he,
          init: i,
          uP: g,
          aC: d,
          rC: u,
          hC: le,
          fire: de,
          gW: pe,
          rAF: fe,
        })
      );
    })(e, e.document, Date);
    (e.lazySizes = t),
      "object" == typeof module && module.exports && (module.exports = t);
  })("undefined" != typeof window ? window : {}),
  (function (e, t) {
    function i() {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    }
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0);
  })(window, function (f, c, h) {
    "use strict";
    var g,
      v,
      n = h.cfg,
      d = { string: 1, number: 1 },
      m = /^\-*\+*\d+\.*\d*$/,
      y = /^picture$/i,
      w = /\s*\{\s*width\s*\}\s*/i,
      u = /\s*\{\s*height\s*\}\s*/i,
      b = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
      k = /^\[.*\]|\{.*\}$/,
      x = /^(?:auto|\d+(px)?)$/,
      p = c.createElement("a"),
      e = c.createElement("img"),
      T = "srcset" in e && !("sizes" in e),
      C = !!f.HTMLPictureElement && !T;
    function S(e, t, i) {
      var o,
        r,
        s,
        n = 0,
        a = 0,
        l = i;
      if (e) {
        if ("container" === t.ratio) {
          for (n = l.scrollWidth, a = l.scrollHeight; !((n && a) || l === c); )
            (n = (l = l.parentNode).scrollWidth), (a = l.scrollHeight);
          n && a && (t.ratio = t.traditionalRatio ? a / n : n / a);
        }
        (o = e),
          (r = t),
          ((s = []).srcset = []),
          r.absUrl && (p.setAttribute("href", o), (o = p.href)),
          (o = ((r.prefix || "") + o + (r.postfix || "")).replace(
            b,
            function (e, t) {
              return d[typeof r[t]] ? r[t] : e;
            }
          )),
          r.widths.forEach(function (e) {
            var t = r.widthmap[e] || e,
              i = r.aspectratio || r.ratio,
              n = !r.aspectratio && v.traditionalRatio,
              i = {
                u: o
                  .replace(w, t)
                  .replace(
                    u,
                    i ? (n ? Math.round(e * i) : Math.round(e / i)) : ""
                  ),
                w: e,
              };
            s.push(i), s.srcset.push((i.c = i.u + " " + e + "w"));
          }),
          ((e = s).isPicture = t.isPicture),
          T && "IMG" == i.nodeName.toUpperCase()
            ? i.removeAttribute(g.srcsetAttr)
            : i.setAttribute(g.srcsetAttr, e.srcset.join(", ")),
          Object.defineProperty(i, "_lazyrias", { value: e, writable: !0 });
      }
    }
    function A(e) {
      return (
        e.getAttribute(e.getAttribute("data-srcattr") || v.srcAttr) ||
        e.getAttribute(g.srcsetAttr) ||
        e.getAttribute(g.srcAttr) ||
        e.getAttribute("data-pfsrcset") ||
        ""
      );
    }
    !(function () {
      var e,
        t = {
          prefix: "",
          postfix: "",
          srcAttr: "data-src",
          absUrl: !1,
          modifyOptions: function () {},
          widthmap: {},
          ratio: !1,
          traditionalRatio: !1,
          aspectratio: !1,
        };
      for (e in ((g = h && h.cfg).supportsType ||
        (g.supportsType = function (e) {
          return !e;
        }),
      g.rias || (g.rias = {}),
      "widths" in (v = g.rias) ||
        ((v.widths = []),
        (function (e) {
          for (var t, i = 0; !t || t < 3e3; )
            30 < (i += 5) && (i += 1), e.push((t = 36 * i));
        })(v.widths)),
      t))
        e in v || (v[e] = t[e]);
    })(),
      addEventListener(
        "lazybeforesizes",
        function (e) {
          if (e.detail.instance == h) {
            var t,
              i,
              n,
              o,
              r,
              s,
              a,
              l,
              c,
              d = e.target;
            if (
              e.detail.dataAttr &&
              !e.defaultPrevented &&
              !v.disabled &&
              (a = d.getAttribute(g.sizesAttr) || d.getAttribute("sizes")) &&
              x.test(a)
            ) {
              var u,
                p = A(d),
                e = (function (o, e) {
                  function i(e, t) {
                    var i,
                      n = o.getAttribute("data-" + e);
                    if (
                      (n ||
                        ((i = r.getPropertyValue("--ls-" + e)) &&
                          (n = i.trim())),
                      n)
                    ) {
                      if ("true" == n) n = !0;
                      else if ("false" == n) n = !1;
                      else if (m.test(n)) n = parseFloat(n);
                      else if ("function" == typeof v[e]) n = v[e](o, n);
                      else if (k.test(n))
                        try {
                          n = JSON.parse(n);
                        } catch (e) {}
                      s[e] = n;
                    } else
                      e in v && "function" != typeof v[e]
                        ? (s[e] = v[e])
                        : t && "function" == typeof v[e] && (s[e] = v[e](o, n));
                  }
                  var t,
                    r = f.getComputedStyle(o),
                    n = o.parentNode,
                    s = { isPicture: !(!n || !y.test(n.nodeName || "")) };
                  for (t in v) i(t);
                  return (
                    e.replace(b, function (e, t) {
                      t in s || i(t, !0);
                    }),
                    s
                  );
                })((u = d), p);
              if (
                (v.modifyOptions.call(u, { target: u, details: e, detail: e }),
                h.fire(u, "lazyriasmodifyoptions", e),
                (l = w.test((t = e).prefix) || w.test(t.postfix)),
                t.isPicture && (i = d.parentNode))
              )
                for (
                  o = 0, r = (n = i.getElementsByTagName("source")).length;
                  o < r;
                  o++
                )
                  (l || w.test((s = A(n[o])))) && (S(s, t, n[o]), (c = !0));
              l || w.test(p)
                ? (S(p, t, d), (c = !0))
                : c &&
                  (((p = []).srcset = []),
                  (p.isPicture = !0),
                  Object.defineProperty(d, "_lazyrias", {
                    value: p,
                    writable: !0,
                  })),
                c &&
                  (C
                    ? d.removeAttribute(g.srcAttr)
                    : "auto" != a &&
                      ((a = { width: parseInt(a, 10) }),
                      E({ target: d, detail: a })));
            }
          }
        },
        !0
      );
    var o,
      E =
        ((o = function (e) {
          var t, i;
          e.detail.instance == h &&
            ((i = e.target),
            T || !(f.respimage || f.picturefill || n.pf)
              ? ("_lazyrias" in i || (e.detail.dataAttr && $(i, !0))) &&
                (t = (function (e, t) {
                  var i,
                    n,
                    o,
                    r,
                    s,
                    a = e._lazyrias;
                  if (a.isPicture && f.matchMedia)
                    for (
                      n = 0,
                        o = (i = e.parentNode.getElementsByTagName("source"))
                          .length;
                      n < o;
                      n++
                    )
                      if (
                        $(i[n]) &&
                        !i[n].getAttribute("type") &&
                        (!(r = i[n].getAttribute("media")) ||
                          (matchMedia(r) || {}).matches)
                      ) {
                        a = i[n]._lazyrias;
                        break;
                      }
                  return (
                    (!a.w || a.w < t) &&
                      ((a.w = t),
                      (a.d =
                        ((e = e),
                        (s = f.devicePixelRatio || 1),
                        (e = h.getX && h.getX(e)),
                        Math.min(e || s, 2.4, s))),
                      (s = (function (e) {
                        for (
                          var t, i, n = e.length, o = e[n - 1], r = 0;
                          r < n;
                          r++
                        )
                          if ((((o = e[r]).d = o.w / e.w), o.d >= e.d)) {
                            !o.cached &&
                              (t = e[r - 1]) &&
                              t.d > e.d - 0.13 * Math.pow(e.d, 2.2) &&
                              ((i = Math.pow(t.d - 0.6, 1.6)),
                              t.cached && (t.d += 0.15 * i),
                              t.d + (o.d - e.d) * i > e.d && (o = t));
                            break;
                          }
                        return o;
                      })(a.sort(l)))),
                    s
                  );
                })(i, e.detail.width)) &&
                t.u &&
                i._lazyrias.cur != t.u &&
                ((i._lazyrias.cur = t.u),
                (t.cached = !0),
                h.rAF(function () {
                  i.setAttribute(g.srcAttr, t.u), i.setAttribute("src", t.u);
                }))
              : c.removeEventListener("lazybeforesizes", o));
        }),
        C ? (o = function () {}) : addEventListener("lazybeforesizes", o),
        o);
    function l(e, t) {
      return e.w - t.w;
    }
    function $(e, t) {
      var i;
      return (
        !e._lazyrias &&
          h.pWS &&
          (i = h.pWS(e.getAttribute(g.srcsetAttr || ""))).length &&
          (Object.defineProperty(e, "_lazyrias", { value: i, writable: !0 }),
          t &&
            e.parentNode &&
            (i.isPicture = "PICTURE" == e.parentNode.nodeName.toUpperCase())),
        e._lazyrias
      );
    }
  }),
  (function (e, t) {
    function i() {
      t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
    }
    (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0);
  })(window, function (e, l, c) {
    "use strict";
    var d, u, p, f, n, o, r, h, g;
    e.addEventListener &&
      ((d = c.cfg),
      (u = /\s+/g),
      (p = /\s*\|\s+|\s+\|\s*/g),
      (f = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/),
      (n = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/),
      (o = /\(|\)|'/),
      (r = { contain: 1, cover: 1 }),
      (h = function (e, t) {
        var i;
        t &&
          ((i = t.match(n)) && i[1]
            ? e.setAttribute("type", i[1])
            : e.setAttribute("media", d.customMedia[t] || t));
      }),
      (g = function (e) {
        var t, i;
        e.target._lazybgset &&
          ((i = (t = e.target)._lazybgset),
          (e = t.currentSrc || t.src) &&
            ((e = c.fire(i, "bgsetproxy", {
              src: e,
              useSrc: o.test(e) ? JSON.stringify(e) : e,
            })).defaultPrevented ||
              (i.style.backgroundImage = "url(" + e.detail.useSrc + ")")),
          t._lazybgsetLoading &&
            (c.fire(i, "_lazyloaded", {}, !1, !0), delete t._lazybgsetLoading));
      }),
      addEventListener("lazybeforeunveil", function (e) {
        var t, i, n, o, r, s, a;
        !e.defaultPrevented &&
          (r = e.target.getAttribute("data-bgset")) &&
          ((s = e.target),
          ((a = l.createElement("img")).alt = ""),
          (a._lazybgsetLoading = !0),
          (e.detail.firesLoad = !0),
          (t = r),
          (i = s),
          (e = a),
          (n = l.createElement("picture")),
          (o = i.getAttribute(d.sizesAttr)),
          (r = i.getAttribute("data-ratio")),
          (s = i.getAttribute("data-optimumx")),
          i._lazybgset &&
            i._lazybgset.parentNode == i &&
            i.removeChild(i._lazybgset),
          Object.defineProperty(e, "_lazybgset", { value: i, writable: !0 }),
          Object.defineProperty(i, "_lazybgset", { value: n, writable: !0 }),
          (t = t.replace(u, " ").split(p)),
          (n.style.display = "none"),
          (e.className = d.lazyClass),
          1 != t.length || o || (o = "auto"),
          t.forEach(function (e) {
            var t,
              i = l.createElement("source");
            o && "auto" != o && i.setAttribute("sizes", o),
              (t = e.match(f))
                ? (i.setAttribute(d.srcsetAttr, t[1]), h(i, t[2]), h(i, t[3]))
                : i.setAttribute(d.srcsetAttr, e),
              n.appendChild(i);
          }),
          o &&
            (e.setAttribute(d.sizesAttr, o),
            i.removeAttribute(d.sizesAttr),
            i.removeAttribute("sizes")),
          s && e.setAttribute("data-optimumx", s),
          r && e.setAttribute("data-ratio", r),
          n.appendChild(e),
          i.appendChild(n),
          setTimeout(function () {
            c.loader.unveil(a),
              c.rAF(function () {
                c.fire(a, "_lazyloaded", {}, !0, !0),
                  a.complete && g({ target: a });
              });
          }));
      }),
      l.addEventListener("load", g, !0),
      e.addEventListener(
        "lazybeforesizes",
        function (e) {
          var t, i, n;
          e.detail.instance == c &&
            e.target._lazybgset &&
            e.detail.dataAttr &&
            ((i = e.target._lazybgset),
            (n = (
              getComputedStyle(i) || { getPropertyValue: function () {} }
            ).getPropertyValue("background-size")),
            !r[n] && r[i.style.backgroundSize] && (n = i.style.backgroundSize),
            r[(t = n)] &&
              ((e.target._lazysizesParentFit = t),
              c.rAF(function () {
                e.target.setAttribute("data-parent-fit", t),
                  e.target._lazysizesParentFit &&
                    delete e.target._lazysizesParentFit;
              })));
        },
        !0
      ),
      l.documentElement.addEventListener("lazybeforesizes", function (e) {
        var t;
        !e.defaultPrevented &&
          e.target._lazybgset &&
          e.detail.instance == c &&
          (e.detail.width =
            ((t = e.target._lazybgset),
            (e = c.gW(t, t.parentNode)),
            (!t._lazysizesWidth || e > t._lazysizesWidth) &&
              (t._lazysizesWidth = e),
            t._lazysizesWidth));
      }));
  }),
  (function (e, t) {
    var i;
    e &&
      ((i = function () {
        t(e.lazySizes), e.removeEventListener("lazyunveilread", i, !0);
      }),
      (t = t.bind(null, e, e.document)),
      "object" == typeof module && module.exports
        ? t(require("lazysizes"))
        : "function" == typeof define && define.amd
        ? define(["lazysizes"], t)
        : e.lazySizes
        ? i()
        : e.addEventListener("lazyunveilread", i, !0));
  })("undefined" != typeof window ? window : 0, function (o, g, v) {
    "use strict";
    function r(e, t, i, n) {
      function o() {
        a &&
          v.rAF(function () {
            v.rC(t, "ls-blur-up-is-loading");
            try {
              a.parentNode.removeChild(a);
            } catch (e) {}
            a = null;
          });
      }
      function r(e) {
        p++, (d = e || d), e ? o() : 1 < p && setTimeout(o, 5e3);
      }
      function s() {
        t.removeEventListener("load", s),
          t.removeEventListener("error", s),
          a &&
            v.rAF(function () {
              a && v.aC(a, "ls-original-loaded");
            }),
          "always" != n && (!c || Date.now() - u < 66) ? r(!0) : r();
      }
      var a,
        l,
        c = !1,
        d = !1,
        u = "always" == n ? 0 : Date.now(),
        p = 0,
        f = (e || t).parentNode;
      i &&
        ((l = function (e) {
          (c = !0),
            (a = a || e.target),
            v.rAF(function () {
              v.rC(t, "ls-blur-up-is-loading"),
                a && v.aC(a, "ls-blur-up-loaded");
            }),
            a &&
              (a.removeEventListener("load", l),
              a.removeEventListener("error", l));
        }),
        (a = g.createElement("img")).addEventListener("load", l),
        a.addEventListener("error", l),
        (a.className = "ls-blur-up-img"),
        (a.cssText = t.cssText),
        (a.src = i),
        (a.alt = ""),
        a.setAttribute("aria-hidden", "true"),
        f.insertBefore(a, (e || t).nextSibling),
        "always" != n &&
          ((a.style.visibility = "hidden"),
          v.rAF(function () {
            a &&
              setTimeout(function () {
                a &&
                  v.rAF(function () {
                    !d && a && (a.style.visibility = "");
                  });
              }, v.cfg.blurupCacheDelay || 33);
          }))),
        t.addEventListener("load", s),
        t.addEventListener("error", s),
        v.aC(t, "ls-blur-up-is-loading");
      function h(e) {
        f == e.target &&
          (v.aC(a || t, "ls-inview"),
          r(),
          f.removeEventListener("lazybeforeunveil", h));
      }
      f.getAttribute("data-expand") || f.setAttribute("data-expand", -1),
        f.addEventListener("lazybeforeunveil", h),
        v.aC(f, v.cfg.lazyClass);
    }
    var s = [].slice,
      n = /blur-up["']*\s*:\s*["']*(always|auto)/,
      a = /image\/(jpeg|png|gif|svg\+xml)/;
    o.addEventListener("lazybeforeunveil", function (e) {
      var t,
        n,
        i = e.detail;
      i.instance == v &&
        i.blurUp &&
        r(
          (e =
            "PICTURE" != (e = (t = e.target).parentNode).nodeName ? null : e),
          t,
          ((t = t),
          ((e = e) ? s.call(e.querySelectorAll("source, img")) : [t]).forEach(
            function (e) {
              var t, i;
              n ||
                !(t = e.getAttribute("data-lowsrc")) ||
                ((e =
                  (i = e).getAttribute("data-media") ||
                  i.getAttribute("media")),
                ((i = i.getAttribute("type")) && !a.test(i)) ||
                  (e && !o.matchMedia(v.cfg.customMedia[e] || e).matches)) ||
                (n = t);
            }
          ),
          n ||
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),
          i.blurUp
        );
    }),
      o.addEventListener("lazyunveilread", function (e) {
        var t,
          i = e.detail;
        i.instance == v &&
          ((t = e.target),
          ((e = (
            getComputedStyle(t, null) || { fontFamily: "" }
          ).fontFamily.match(n)) ||
            t.getAttribute("data-lowsrc")) &&
            (i.blurUp = (e && e[1]) || v.cfg.blurupMode || "always"));
      });
  });

